<template>
  <span>
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card v-resize="checkMobile" max-width="1200px" class="mx-auto">
      <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
        <v-expansion-panels v-if="client" v-model="dataPanel" data-testid="client-data-panels" :style="user_role == 'guest' || user_role == 'partner'
          ? 'display: none;'
          : ''
          ">
          <v-expansion-panel v-if="!client.entity">
            <v-expansion-panel-header data-testid="client-panel-header">
              <h2 v-if="!isMobile" class="mb-0 d-flex">
                {{ clientFullName(client) }}
                {{ formatPhone(client.phone) }}
                <!-- FT-184 REQ-12: метка «через агента» (без метки не рисуется) -->
                <agent-marker record-type="Client" :record-id="client.id" />
              </h2>
              <h4 v-else class="subtitle-1 mb-0 d-flex">
                {{ clientFullName(client) }}
                {{ formatPhone(client.phone) }}
                <agent-marker record-type="Client" :record-id="client.id" />
              </h4>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.lastname" :label="$t('bookings.lastname')" outlined hide-details :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.name" :label="$t('bookings.name')" outlined hide-details :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.middlename" :label="$t('bookings.middlename')" outlined hide-details
                    :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.fio" :label="$t('clients.fio')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <phone-field ref="clientPhoneField" v-model="client.phone" mode="strict"
                    :default-country="phoneDefaultCountry" :needs-check="!!client.phone_needs_check"
                    :label="$t('custom.phone')" outlined hide-details data-testid="client-phone-field"
                    :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      " />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.email" :label="$t('custom.email')" type="email" outlined hide-details
                    :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      ">
                    <template v-slot:append>
                      <!-- Адрес отклонён Postmark (invalid_email): письма не доставляются -->
                      <v-icon v-if="client.invalid_email" small color="warning" v-tooltip="{
                        content: $t('custom.invalid_email_tooltip'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                      }">mdi-email-alert-outline</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-if="showEditBirthday" v-model="client.birthday" @click="showEditBirthday = true"
                    :label="$t('bookings.birthdate')" :placeholder="$t('bookings.birthdate_plc')" outlined hide-details
                    :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  <v-text-field v-else v-model="birthday_non_format" :label="$t('bookings.birthdate')"
                    v-mask="'##.##.####'" :placeholder="$t('bookings.birthdate_plc')" outlined hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select v-model="client.category" :items="customer_category" item-text="text" item-value="value"
                    :label="$t('bookings.client_category')" outlined></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.passport_series" :label="$t('custom.passport_series')" outlined
                    hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.passport_number" :label="$t('custom.passport_number')" outlined
                    hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="client.passport_issued" :label="$t('custom.passport_issued')" outlined
                    hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="client.passport_issued_date" type="date"
                    :label="$t('custom.passport_issued_date')" outlined hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="client.passport_expired_date" type="date"
                    :label="$t('custom.passport_expired_date')" outlined hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.inn" :label="$t('custom.tax_number')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.country" :label="$t('custom.country')" outlined
                    hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.city" :label="$t('custom.city')" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="client.address" :label="$t('custom.address')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
                    :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="client.driver_series" :label="$t('custom.license_series')" outlined
                    hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="client.driver_number" :label="$t('custom.license_number')" outlined
                    hide-details :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="client.driver_issued" :label="$t('custom.license_issued')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="client.driver_issued_date" type="date" :label="$t('custom.driver_license_issued_date')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="client.driver_expired_date" type="date" :label="$t('custom.driver_license_expired_date')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="client.taxi_license" :label="$t('custom.taxi_license')" outlined :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="client.sale" :label="$t('custom.sale_perc')" outlined
                    hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="client.sale_cash" :label="$t('custom.sale_rub', { currency: currency })"
                    outlined hide-details></v-text-field>
                </v-col>
                <!-- Лимит долга и «Источник» — парой в собственном ряду: ряд не зависит от того, сколько колонок
                     набралось выше (иначе «Источник» md8 перенёсся бы и оставил дыру) -->
                <v-col cols="12" data-testid="client-limit-source-row">
                  <v-row>
                    <v-col cols="12" md="4" v-if="isManagerPlus">
                      <v-text-field v-model="client.periodic_credit_limit" type="number" min="0"
                        :label="$t('clients.periodic_credit_limit')" data-testid="client-periodic-credit-limit" outlined
                        :hint="$t('clients.periodic_credit_limit_hint', { currency: currency })" persistent-hint></v-text-field>
                    </v-col>
                    <v-col cols="12" :md="isManagerPlus ? 8 : 12">
                      <v-select v-if="clients_sources" v-model="client.source" :items="clients_sources"
                        :label="$t('custom.source')" outlined></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="12" v-if="isTaxiMode">
                  <v-select v-model="client.taxi_payment_model" :items="taxi_payment_models"
                    :label="$t('taxi.payment_models.payment_model')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-select>
                  <v-text-field v-if="client.taxi_payment_model == 1 || client.taxi_payment_model == 2"
                    v-model="client.commission_percent" :label="$t('taxi.payment_models.commission_percent')" outlined
                    :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea v-model="client.dop_info" :label="$t('clients.add_info')" rows="1" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-textarea>
                </v-col>
                <v-col cols="12" md="12" class="text-center">
                  <v-btn color="success" class="mr-2" data-testid="client-save-btn" @click="editSave">{{ $t("custom.save")
                  }}<v-icon class="ml-1">
                      mdi-content-save-check-outline
                    </v-icon></v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-else>
            <v-expansion-panel-header>
              <h2 v-if="!isMobile" class="mb-0 d-flex">
                {{ client.reg_form }} {{ client.entity_name }} {{ formatPhone(client.entity_phone) }}
                <agent-marker record-type="Client" :record-id="client.id" />
              </h2>
              <h4 v-else class="subtitle-1 mb-0 d-flex">
                {{ client.reg_form }} {{ client.entity_name }} {{ formatPhone(client.entity_phone) }}
                <agent-marker record-type="Client" :record-id="client.id" />
              </h4>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.entity_name" :label="$t('custom.company_name')"
                      :placeholder="$t('custom.company_name_placeholder')" outlined :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.short_entity_name" :label="$t('custom.company_name_short')"
                      :placeholder="$t('custom.company_name_short_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.reg_form" :label="$t('custom.reg_form')"
                      :placeholder="$t('custom.reg_form_plc')" outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.inn" :label="$t('custom.tax_number')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.ogrn" :label="$t('custom.entity_number')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.ceo" :label="$t('custom.face')" :placeholder="$t('custom.face_plc')"
                      outlined :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md4>
                    <phone-field ref="clientPhoneField" v-model="client.entity_phone" mode="soft"
                      :default-country="phoneDefaultCountry" :needs-check="!!client.entity_phone_needs_check"
                      :label="$t('custom.entity_phone')" outlined
                      :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        " />
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.email" :label="$t('custom.email')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      ">
                      <template v-slot:append>
                        <!-- Адрес отклонён Postmark (invalid_email): письма не доставляются -->
                        <v-icon v-if="client.invalid_email" small color="warning" v-tooltip="{
                          content: $t('custom.invalid_email_tooltip'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                        }">mdi-email-alert-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-select v-model="client.category" :items="customer_category"
                      :label="$t('bookings.client_category')" outlined></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md2>
                    <v-text-field v-model="client.country" :label="$t('custom.country')" outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md2>
                    <v-text-field v-model="client.city" :label="$t('custom.city')" outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-textarea v-model="client.entity_adress" :label="$t('custom.entity_address_2')" outlined rows="1"
                      auto-grow :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-textarea v-model="client.address" :label="$t('custom.entity_address_3')" outlined rows="1"
                      auto-grow :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="client.acc_number" :label="$t('custom.entity_bank_number')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="client.bank" :label="$t('custom.bank_name')"
                      :placeholder="$t('custom.bank_name_plc')" outlined :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="client.korr" :label="$t('custom.bank_correspondent')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="client.bik" :label="$t('custom.bank_number')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.sale" :label="$t('custom.sale_perc')" outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.sale_cash" :label="$t('custom.sale_rub', { currency: currency })"
                      outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 v-if="isManagerPlus">
                    <v-text-field v-model="client.periodic_credit_limit" type="number" min="0"
                      :label="$t('clients.periodic_credit_limit')" data-testid="client-periodic-credit-limit-entity" outlined
                      :hint="$t('clients.periodic_credit_limit_hint', { currency: currency })" persistent-hint></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="client.doc_number" :label="$t('custom.doc_number')" outlined
                      :placeholder="$t('custom.doc_number_plc')" :style="user_role == 'guest' || user_role == 'partner'
                        ? 'display: none;'
                        : ''
                        "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 class="mx-auto">
                    <v-select v-if="clients_sources" v-model="client.source" :items="clients_sources"
                      :label="$t('custom.source')" outlined></v-select>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-2 mb-2"></v-divider>
                <v-layout row wrap>
                  <v-flex>
                    <v-textarea v-model="client.dop_info" :label="$t('clients.add_info')" :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex class="text-center">
                    <v-btn color="success" @click="editSave">{{ $t("custom.save")
                    }}<v-icon class="ml-1">
                        mdi-content-save-check-outline
                      </v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          
          <!-- Проверка надежности клиента через Parser API -->
          <v-expansion-panel v-if="main_company && main_company.plan && main_company.plan.included_services.includes('check_client_reliability')">
            <v-expansion-panel-header>
              <div class="d-flex align-center">
                <v-icon left color="primary">mdi-shield-search</v-icon>
                <h3 v-if="!isMobile" class="mb-0">
                  {{ $t('parser_api.tab_title') }}
                </h3>
                <h4 v-else class="subtitle-1 mb-0">
                  {{ $t('parser_api.tab_title') }}
                </h4>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <ClientCheckTab v-if="client && client.id" :client="client" @update-client-inn="$set(client, 'inn', $event)" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- FT-076: задачи по клиенту — третья панель в общей группе -->
          <v-expansion-panel v-if="client && client.id">
            <v-expansion-panel-header>
              <div class="d-flex align-center">
                <v-icon left color="primary">mdi-checkbox-marked-circle-outline</v-icon>
                <h3 v-if="!isMobile" class="mb-0">{{ $t('tasks.title') }}</h3>
                <h4 v-else class="subtitle-1 mb-0">{{ $t('tasks.title') }}</h4>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <task-list taskable-type="Client" :taskable-id="client.id" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- FT-232: раскрытие звонков загружает историю только после явного открытия. -->
        <ClientCalls v-if="client && client.id && isStaff && telephony" :client-id="client.id" :telephony="telephony" :is-staff="isStaff" @refresh="loadClientCardData" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
        <v-flex class="d-flex justify-space-between">
          <v-switch v-model="client.problems" :label="$t('clients.bad')" hide-details class="mt-0 mx-2"
            @change="editSave()"></v-switch>
          <v-icon v-if="company && company.whatsapp && client.phone && client.phone.length > 6 && isStaff" class="mr-2 green--text"
            @click="replaceToWhatsAppPage()">
            mdi-whatsapp
          </v-icon>
        </v-flex>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" v-if="!client.entity">
            <v-row>
              <v-col cols="12" v-if="client.debtor">
                <h2 class="orange darken-4">{{ $t("clients.have_debt") }}</h2>
              </v-col>
              <v-col cols="12" v-if="client.problems">
                <h2 class="red lighten-1">{{ $t("clients.bad_warn") }}</h2>
              </v-col>
              <v-col cols="12">
                <v-textarea v-if="client.problems" v-model="client.problems_description" outlined
                  @blur="editSave()"></v-textarea>
              </v-col>
              <v-col v-if="!isTaxiMode" cols="12" class="d-flex justify-space-between align-center mb-3">
                <v-text-field v-model="client.balance" readonly :label="$t('other.balance')" hide-details
                  prepend-icon="mdi-wallet-outline" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                <v-icon class="ml-2 mt-3 info--text" @click="showTopUpBalanceDialog = true" data-testid="client-topup-open" v-tooltip="{
                  content: $t('other.add_balance'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 800,
                    hide: 500,
                  },
                }">
                  mdi-wallet-plus
                </v-icon>
                <v-icon v-if="yandexPayAvailable" class="ml-2 mt-3 error--text" @click="openYandexPayDialog" v-tooltip="{
                  content: $t('yandex_pay.pay_with_yandex'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 800,
                    hide: 500,
                  },
                }">
                  mdi-alpha-y-circle
                </v-icon>
                <!-- FT-173 REQ-11: точка входа в мастер «Аренда с выкупом», client_id
                     в query подставляется в шаг 2 (REQ-02, ContractWizard.vue).
                     STEP-22 (F9, REQ-21): v-btn icon вместо голого v-icon —
                     см. тот же комментарий в CarCard.vue. -->
                <v-btn
                  v-if="client && client.id && rentToOwnEntryVisible"
                  icon
                  class="ml-2 mt-3"
                  :aria-label="$t('rent_to_own.wizard.entry_button')"
                  data-testid="rent-to-own-entry-client-button"
                  @click="openRentToOwnWizard"
                  v-tooltip="{
                    content: $t('rent_to_own.wizard.entry_button'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 800,
                      hide: 500,
                    },
                  }"
                >
                  <v-icon>mdi-car-key</v-icon>
                </v-btn>
                <stripe-payment-dialog
                  v-if="client && client.id"
                  ref="stripePaymentDialog2"
                  :client="client"
                  :company="company"
                  :currency="currency"
                  :check-admin-manager="checkAdminManager"
                  @payments-updated="handleStripePaymentsUpdated"
                />
              </v-col>
              <v-col v-if="isTaxiMode" cols="12">
                <v-row>
                  <v-col cols="12">
                    <!-- Основной баланс -->
                    <v-card flat :loading="isLoadingGetFullBalance"
                      :class="parseFloat(client.balance || 0) >= 0 ? 'green--lighten-5 green--text--darken-3' : 'red--lighten-5 red--text--darken-3'"
                      :color="$vuetify.theme.dark ? (parseFloat(client.balance || 0) >= 0 ? 'green darken-4' : 'red darken-4') : (parseFloat(client.balance || 0) >= 0 ? 'green lighten-5' : 'red lighten-5')">
                      <v-card-text class="pa-4">
                        <div class="d-flex align-center">
                          <span class="text-h6 font-weight-bold"
                            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
                            Основной баланс
                          </span>
                          <v-spacer></v-spacer>
                          <v-btn icon color="success" @click="openTransactionDialog('add')"
                            :disabled="isLoadingTransaction" class="mr-1">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <span class="text-h5 font-weight-bold" :class="balanceColor()">
                            {{ parseFloat(client.balance || 0).toFixed(2) }}
                          </span>
                          <v-btn icon color="primary" @click="getFullBalance(client)"
                            :disabled="isLoadingGetFullBalance" class="ml-1">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <!-- Заблокированный баланс -->
                    <v-card flat class="mb-4" :loading="isLoadingGetFullBalance"
                      :class="parseFloat(client.blocked_balance || 0) > 0 ? 'orange--lighten-5 orange--text--darken-3' : 'grey--lighten-5 grey--text--darken-3'"
                      :color="$vuetify.theme.dark ? (parseFloat(client.blocked_balance || 0) > 0 ? 'orange darken-4' : 'grey darken-4') : (parseFloat(client.blocked_balance || 0) > 0 ? 'orange lighten-5' : 'grey lighten-5')">
                      <v-card-text class="pa-4">
                        <div class="d-flex justify-space-between align-center">
                          <span class="text-h6 font-weight-bold"
                            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Заблокировано</span>
                          <span class="text-h5 font-weight-bold"
                            :class="parseFloat(client.blocked_balance || 0) > 0 ? 'orange--text darken-2' : 'grey--text'">
                            {{ parseFloat(client.blocked_balance || 0).toFixed(2) }} ₽
                          </span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-else>
            <v-row>
              <v-col cols="12" v-if="client.debtor">
                <h2 class="orange darken-4">{{ $t("clients.have_debt") }}</h2>
              </v-col>
              <v-col cols="12" v-if="client.problems">
                <h2 class="red lighten-1 white--text">
                  {{ $t("clients.bad_warn") }}
                </h2>
              </v-col>
              <v-col cols="12" v-if="client.problems">
                <v-textarea v-if="client.problems" v-model="client.problems_description" outlined></v-textarea>
              </v-col>
              <v-col v-if="!isTaxiMode" cols="12" class="d-flex justify-space-between align-center mb-3">
                <v-text-field v-model="client.balance" readonly :label="$t('other.balance')" hide-details
                  prepend-icon="mdi-wallet-outline" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    "></v-text-field>
                <v-icon class="ml-2 mt-3 info--text" @click="showTopUpBalanceDialog = true" data-testid="client-topup-open" v-tooltip="{
                  content: $t('other.add_balance'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 800,
                    hide: 500,
                  },
                }">
                  mdi-wallet-plus
                </v-icon>
                <v-icon v-if="yandexPayAvailable" class="ml-2 mt-3 error--text" @click="openYandexPayDialog" v-tooltip="{
                  content: $t('yandex_pay.pay_with_yandex'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 800,
                    hide: 500,
                  },
                }">
                  mdi-alpha-y-circle
                </v-icon>
                <!-- FT-173 REQ-11: точка входа в мастер «Аренда с выкупом», client_id
                     в query подставляется в шаг 2 (REQ-02, ContractWizard.vue).
                     STEP-22 (F9, REQ-21): v-btn icon вместо голого v-icon —
                     см. тот же комментарий в CarCard.vue. -->
                <v-btn
                  v-if="client && client.id && rentToOwnEntryVisible"
                  icon
                  class="ml-2 mt-3"
                  :aria-label="$t('rent_to_own.wizard.entry_button')"
                  data-testid="rent-to-own-entry-client-button"
                  @click="openRentToOwnWizard"
                  v-tooltip="{
                    content: $t('rent_to_own.wizard.entry_button'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 800,
                      hide: 500,
                    },
                  }"
                >
                  <v-icon>mdi-car-key</v-icon>
                </v-btn>
                <stripe-payment-dialog
                  v-if="client && client.id"
                  ref="stripePaymentDialog"
                  :client="client"
                  :company="company"
                  :currency="currency"
                  :check-admin-manager="checkAdminManager"
                  @payments-updated="handleStripePaymentsUpdated"
                />
              </v-col>
            </v-row>
          </v-col>
          <!-- Раздел такси -->
          <v-col cols="12" v-if="isTaxiMode">
            <TaxiDriverInfo :client="client" />
          </v-col>
          <!-- Долги -->
          <v-col cols="12" v-if="debts.length > 0">
            <h1>{{ $t('custom.debts') }}</h1>
            <v-data-table :headers="debts_headers" :items="debts" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" :search="search" :sort-by="['created_at']" :sort-desc="[true]"
              dense mobile-breakpoint="100">
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center">
                    <router-link :to="{ path: `/debts/${props.item.id}` }">{{
                      props.item.id
                      }}</router-link>
                  </td>
                  <td class="text-center">
                    {{ returnDate(props.item.created_at) }}
                  </td>
                  <td class="text-center" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    ">
                    <router-link :to="{ path: `/clients/${props.item.client_id}` }">{{ props.item.client_name
                    }}</router-link>
                  </td>
                  <td class="text-center">
                    <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">{{ props.item.booking_id
                    }}</router-link>
                  </td>
                  <td class="text-center">{{ translateDebtGroup(props.item.group) }}</td>
                  <td class="text-center">{{ props.item.description }}</td>
                  <td class="text-center">
                    {{ props.item.sum }}{{ currency }}
                  </td>
                  <td class="text-center">
                    {{ props.item.paid }}{{ currency }}
                  </td>
                  <!-- Состояние -->
                  <td class="text-center">
                    <v-btn :color="stateDebtColor(props.item.state)" small block>
                      {{ translateDebtState(props.item.state) }}
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                {{ $t("custom.no_data_in_table") }}
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                {{ $t("tables.no_search_result", { msg: search }) }}
              </v-alert>
            </v-data-table>
          </v-col>
          <!-- Пополнения баланса -->
          <v-col cols="12" v-if="counts.length > 0">
            <h2 class="mb-3">
              {{ $t("bookings.counts") }}
              <v-icon v-if="(isAdminPlus)" @click="toXlsx()" class="mx-2"
                style="cursor: pointer" color="success">
                mdi-file-excel-outline
              </v-icon>
            </h2>
            <v-data-table :headers="counts_headers" :items="counts" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" item-key="id" class="elevation-1" dense :items-per-page="10"
              mobile-breakpoint="100" :sort-by="['created_at']" :sort-desc="[true]" :footer-props="tableFooterProps([7, 14, 50, 100, -1])">
              <template slot="header" slot-scope="props">
                <tr>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="item" slot-scope="props">
                <tr :class="props.item.operation && props.item.sum < 0
                  ? 'red--text'
                  : ''
                  ">
                  <td :class="props.item.canceled ? 'text-center text-decoration-line-through' : 'text-center'">
                    {{ props.item.id }}
                  </td>
                  <td class="text-center" nowrap>
                    {{ returnDate(props.item.created_at) }}
                  </td>
                  <td :class="props.item.canceled ? 'text-center text-decoration-line-through' : 'text-center'">
                    {{ translateCategory(props.item.group) }}
                  </td>
                  <td :class="props.item.canceled ? 'text-center text-decoration-line-through' : 'text-center'">
                    {{ props.item.description }}
                  </td>
                  <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                    {{ props.item.operation ? "" : "-" }}{{ props.item.sum }}{{
                      findCurrencySymbol(props.item.currency_id) }}
                    <span
                      v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                      ({{ props.item.rated_sum }})
                    </span>
                  </td>
                  <td v-else class="text-center">
                    {{ props.item.operation ? "" : "-" }}{{ props.item.sum }}{{ currency }}
                  </td>
                  <td class="text-center" v-if="props.item.operation">
                    <v-icon class="text-center" style="color: green">
                      mdi-plus-circle-outline
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="!props.item.operation">
                    <v-icon class="text-center" style="color: tomato">
                      mdi-minus-circle-outline
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="props.item.cash">
                    <v-icon class="text-center" color="success" v-tooltip="{
                      content: $t('tooltips.cash_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-cash
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="props.item.cashless">
                    <v-icon class="text-center" color="warning" v-tooltip="{
                      content: $t('tooltips.terminal_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-contactless-payment-circle-outline
                    </v-icon>
                    <v-icon class="text-center" v-if="props.item.client_balance" color="error" v-tooltip="{
                      content: $t('money.client_balance'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-account-arrow-right
                    </v-icon>
                    <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                      mdi-alpha-y-circle
                    </v-icon>
                    <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                      mdi-alpha-s-circle-outline
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="props.item.entity">
                    <v-icon class="text-center" color="secondery" v-tooltip="{
                      content: $t('tooltips.entity_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-bank
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="props.item.cash_card">
                    <v-icon class="text-center" color="info" v-tooltip="{
                      content: $t('money.card_to_card'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-credit-card-check-outline
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="props.item.client_balance && !props.item.yandex_pay && !props.item.stripe">
                    <v-icon class="text-center" color="error" v-tooltip="{
                      content: $t('money.client_balance'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-account-arrow-right
                    </v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- Платежи через Яндекс Пэй -->
          <v-col cols="12" v-if="yandex_pay_payments.length > 0">
            <h2 class="mb-3">
              {{ $t("yandex_pay.history") }}
              <v-icon small class="mx-2" color="primary" @click="loadClientCardData()">
                mdi-refresh
              </v-icon>
            </h2>
            <v-data-table :headers="yandex_pay_headers" :items="yandex_pay_payments" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" :items-per-page="10" :sort-by="['created_at']"
              :sort-desc="[true]" class="elevation-1" dense :footer-props="tableFooterProps([10, 20, 50, -1])">
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center">{{ props.item.id }}</td>
                  <td class="text-center">{{ formatDate(props.item.created_at) }}</td>
                  <td class="text-center">
                    {{ formatYandexPayAmount(props.item.amount) }} {{ props.item.currency || currency }}
                  </td>
                  <td class="text-center">
                    <span v-if="props.item.refunded_amount > 0" class="error--text">
                      {{ formatYandexPayAmount(props.item.refunded_amount) }} {{ props.item.currency || currency }}
                    </span>
                    <span v-else>—</span>
                  </td>
                  <td class="text-center">{{ props.item.order_id }}</td>
                  <td class="text-center">
                    <v-chip small :color="yandexPayStatusColor(props.item.status)" dark>
                      {{ translateYandexPayStatus(props.item.status) }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-btn icon v-if="props.item.payment_url" @click="copyToClipboard(props.item.payment_url)">
                      <v-icon color="primary">mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn icon 
                      v-if="props.item.payment_url"
                      @click="viewYandexPayPayment(props.item)" 
                      :title="$t('yandex_pay.view_payment')">
                      <v-icon color="info">mdi-eye</v-icon>
                    </v-btn>
                    <v-btn icon 
                      :disabled="props.item.status !== 'success' || props.item.refunded_amount >= props.item.amount" 
                      @click="refundYandexPayPayment(props.item)" 
                      :title="$t('yandex_pay.refund')">
                      <v-icon color="error">mdi-cash-refund</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                {{ $t("yandex_pay.no_payments") }}
              </template>
            </v-data-table>
          </v-col>
          <!-- Платежи через Stripe -->
          <v-col cols="12" v-if="stripe_payments.length > 0">
            <stripe-payments-table
              :payments="stripe_payments"
              :currency="currency"
              :is-loading="isLoading"
              @view-payment="viewStripePayment"
              @refund-payment="refundStripePayment"
              @refresh-payments="loadClientCardData"
            />
          </v-col>
          <!-- FT-193 REQ-01: привязка — только пока терминал работает; отвязка (remove_card) доступностью не гейтится,
               поэтому блок остаётся, пока карта привязана -->
          <v-col cols="12" v-if="company.tinkoff_operable || tinkoffCardBound" data-testid="tinkoff-card-block">
            <h2 class="mb-3">
              {{ $t("tinkoff.card_list") }}: {{ client.tinkoff_card_number }}
              <!-- FT-193 CHK-02: карту привязывает и снимает филиал клиента; в чужом филиале сервер ответит 404 -->
              <v-icon @click="openTinkoffConsentDialog()" v-if="company.tinkoff_operable && canManageTinkoffCard && tinkoffCardActionsVisible" class="mx-2" style="cursor: pointer" color="success" data-testid="tinkoff-card-add">
                mdi-credit-card-plus-outline
              </v-icon>
              <v-icon @click="removeCardCreate()" v-if="canManageTinkoffCard && tinkoffCardActionsVisible && tinkoffCardBound" data-testid="tinkoff-card-remove" class="mx-2" style="cursor: pointer"
                color="error">
                mdi-credit-card-remove-outline
              </v-icon>

            </h2>
            <p v-if="showTinkoffOtherBranchHint" class="text--secondary mb-3" data-testid="tinkoff-card-other-branch">
              {{ $t("tinkoff.card_other_branch") }}
            </p>
            <v-data-table :headers="tinkoff_headers" :items="tinkoff_payments" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" :items-per-page="10" :sort-by="['created_at']"
              :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([10, 20, 50, -1])">
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center">
                    {{ props.item.id }}
                  </td>
                  <td class="text-center">
                    {{ formatDate(props.item.created_at) }}
                  </td>
                  <td class="text-center">
                    {{ props.item.sum / 100 }}
                  </td>
                  <td class="text-center">
                    {{ props.item.card_number }}
                  </td>
                  <td class="text-center">
                    {{ props.item.payment_id }}
                  </td>
                  <td class="text-center">
                    {{ props.item.status }}
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                {{ $t("custom.no_data_in_table") }}
              </template>
            </v-data-table>
          </v-col>
          <!-- Брони -->
          <v-col cols="12" v-if="bookings.length > 0">
            <h2 class="mb-3">{{ $t("custom.bookings") }}</h2>
            <v-data-table :headers="headers" :items="bookings" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" item-key="id" class="elevation-1" dense mobile-breakpoint="100"
              :items-per-page="10" :footer-props="tableFooterProps([10, 30, 50, 100, -1])">
              <template slot="header" slot-scope="props">
                <tr>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="item" slot-scope="props">
                <tr :class="{
                  'grey lighten-1': !props.item.ride,
                  'green lighten-4': props.item.ride,
                }">
                  <td class="text-center" :key="props.item.id">
                    <rent-to-own-number-chip v-if="props.item.rent_to_own === true" small :link="false" :booking="props.item" />
                    <template v-else>{{ props.item.id }}</template>
                  </td>
                  <td class="text-center">
                    {{ formatCreatedAt(props.item.created_at) }}
                  </td>
                  <td class="text-center">
                    <v-icon @click="replaceToBooking(props.item)" :title="$t('archive.booking_info')">
                      mdi-eye-outline
                    </v-icon>
                  </td>
                  <td class="text-center">{{ props.item.car_name }}</td>
                  <td class="text-center">{{ props.item.start_date }}</td>
                  <td class="text-center">{{ props.item.end_date }}</td>
                  <td class="text-center">{{ props.item.days }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- Штрафы -->
          <v-col cols="12" v-if="showFines && fines.length > 0">
            <h2 class="mb-3">{{ $t("custom.fines") }}</h2>
            <v-data-table :headers="fines_headers" :items="fines" :search="search_fines" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" :items-per-page="10" :sort-by="['created_at']"
              :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([20, 50, 100, -1])">
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center">
                    <router-link :to="{ path: `/fines/${props.item.number}` }">{{ props.item.number }}</router-link>
                  </td>
                  <td class="text-center" v-if="props.item.date">
                    {{ returnDate(props.item.date) }}
                  </td>
                  <td class="text-center" v-else>
                    {{ formatCreatedAtWithYear(props.item.violation_date) }}
                  </td>
                  <td class="text-center">
                    <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">{{ props.item.booking_id
                    }}</router-link>
                  </td>
                  <td class="text-center">
                    {{ props.item.sum }}{{ currency }}
                  </td>
                  <td class="text-center description-trunc">
                    <read-more v-if="props.item.description &&
                      props.item.description.length > 0
                    " :more-str="$t('custom.read')" :text="props.item.description" link="#"
                      :less-str="$t('custom.less')" :max-chars="20"></read-more>
                  </td>
                  <td class="text-center" v-if="props.item.paid">
                    <v-icon class="text-center" style="color: green">
                      mdi-plus-circle-outline
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="!props.item.paid">
                    <v-icon class="text-center" style="color: tomato">
                      mdi-minus-circle-outline
                    </v-icon>
                  </td>
                  <!-- Состояние -->
                  <td class="text-center">
                    <v-btn :color="stateFineColor(props.item.state)" small block>
                      {{ translateFineState(props.item.state) }}
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                {{ $t("custom.no_data_in_table") }}
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                {{ $t("tables.no_search_result", { msg: search_fines }) }}
              </v-alert>
            </v-data-table>
          </v-col>
          <!-- Счета -->
          <v-col cols="12" v-if="invoices.length > 0">
            <v-divider class="mt-3 mb-3"></v-divider>
            <h2>{{ $t("custom.invoices") }}</h2>
            <v-data-table :headers="headers_invoices" :items="invoices" :search="search_invoices" :loading="isLoading"
              :loading-text="$t('custom.loading_table')" :items-per-page="10" :sort-by="['created_at']"
              mobile-breakpoint="100" :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([20, 50, 100, -1])">
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center">
                    <router-link :to="{ path: `/invoices/${props.item.number}` }">{{ props.item.number }}</router-link>
                  </td>
                  <td class="text-center">{{ returnDate(props.item.date) }}</td>
                  <td class="text-center" :style="user_role == 'guest' || user_role == 'partner'
                    ? 'display: none;'
                    : ''
                    ">
                    <router-link :to="{ path: `/clients/${props.item.client_id}` }">{{ props.item.client_name
                    }}</router-link>
                  </td>
                  <td class="text-center">
                    <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">{{ props.item.booking_id
                    }}</router-link>
                  </td>
                  <td class="text-center">
                    <read-more v-if="props.item.description &&
                      props.item.description.length > 0
                    " :more-str="$t('custom.read')" :text="props.item.description" link="#"
                      :less-str="$t('custom.less')" :max-chars="20"></read-more>
                  </td>
                  <td class="text-center">
                    {{
                      props.item.rent +
                      props.item.deposit +
                      props.item.delivery +
                      props.item.delivery_end +
                      props.item.clean +
                      props.item.gas +
                      props.item.damage +
                      props.item.fines +
                      props.item.mileage +
                      props.item.hours_cost +
                      props.item.insurance +
                      props.item.equipment +
                      (props.item.addons_cost || 0) +
                      props.item.other
                    }}{{ currency }}
                  </td>
                  <td class="text-center">{{ paidInvoice(props.item) }}</td>
                  <td class="text-center">
                    {{ props.item.paid ? props.item.paid : 0 }}{{ currency }}
                  </td>
                  <!-- Состояние -->
                  <td class="text-center">
                    <v-btn :color="stateInvoiceColor(props.item.state)" small block>
                      {{ translateInvoiceState(props.item.state) }}
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                {{ $t("custom.no_data_in_table") }}
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                {{ $t("tables.no_search_result", { msg: search_invoices }) }}
              </v-alert>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <gallery :documents="client.clients_files || []"
              @documentRecognized="onDocumentRecognized"></gallery>
          </v-col>
          <!-- <v-card-text v-if="!uploadDocuments">
            <v-layout row wrap centered class="d-flex text-center justify-center">
              <v-flex xs12 sm12 md12 class="d-flex justify-center">
                <v-checkbox :label="$t('custom.upload_docs')" v-model="uploadDocuments"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text> -->
          <v-col cols="12" class="text-center">
            <!-- <h3 mb-3>{{ $t("custom.uploading_files") }}</h3> -->
            <!-- <v-flex xs12 sm12 md12 class="d-flex text-center justify-center"> -->
            <!-- Потолок на ИСХОДНЫЙ файл: Uppy проверяет restrictions в addFile,
                 то есть ДО компрессора (он препроцессор и работает при отправке).
                 На 10 МБ снимок с айфона отклонялся, хотя сжался бы до единиц
                 мегабайт, — то есть потолок резал ровно те файлы, ради которых
                 сжатие и ставилось. -->
            <uppy @updateClientFiles="updateClientFiles" :max-file-size-in-bytes="50000000" width="100%" height="250px"
              :theme="$vuetify.theme.dark ? 'dark' : 'light'"></uppy>
            <!-- </v-flex> -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <v-dialog v-model="showTopUpBalanceDialog" :retain-focus="false" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          {{ $t('clients.top_up_balance') }}
        </v-card-title>
        <v-card-text>
          <v-flex md12>
            <v-text-field v-model.number="count.sum" data-testid="client-topup-sum" :label="$t('custom.amount')" type="number" @click="count.sum = ''"
              outlined></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-textarea v-model="count.description" :label="$t('custom.description')" rows="1" auto-grow
              outlined></v-textarea>
          </v-flex>
          <v-flex md12>
            <v-flex v-if="!isMobile" xs12 sm12 md12 class="d-inline-flex align-center">
              <v-checkbox v-if="company && company.cash_payment" v-model="count.cash" data-testid="client-topup-cash"
                :disabled="count.cashless || count.cash_card || count.entity" class="mt-0 mr-2" dense hide-details
                :style="count.cashless || count.cash_card || count.entity
                  ? 'opacity: 0.4;'
                  : ''
                  ">
                <template v-slot:label>
                  <v-icon class="text-center mr-2" color="success" size="30">
                    mdi-cash
                  </v-icon>
                  <span>{{ $t("money.cash") }}</span>
                </template>
              </v-checkbox>
              <v-checkbox v-if="company && company.cashless_payment" v-model="count.cashless" data-testid="client-topup-cashless"
                :label="$t('money.terminal')" :disabled="count.cash ||
                  count.cash_card ||
                  count.entity
                  " class="mt-0 mr-2" dense hide-details :style="count.cash ||
                    count.cash_card ||
                    count.entity
                    ? 'opacity: 0.4;'
                    : ''
                    " v-tooltip="{
                      content: $t('tooltips.terminal_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                <template v-slot:label>
                  <v-icon class="text-center mr-2" color="warning">
                    mdi-contactless-payment-circle-outline
                  </v-icon>
                  <span>{{ $t("money.terminal") }}</span>
                </template>
              </v-checkbox>
              <v-checkbox v-if="company && company.card_to_card_payment" v-model="count.cash_card" data-testid="client-topup-cash-card" :disabled="count.cash ||
                count.cashless ||
                count.entity
                " class="mt-0 mr-2" dense hide-details :style="count.cash ||
                  count.cashless ||
                  count.entity
                  ? 'opacity: 0.4;'
                  : ''
                  " v-tooltip="{
                    content: $t('money.card_to_card_2'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">
                <template v-slot:label>
                  <v-icon class="text-center mr-2" color="info">
                    mdi-credit-card-check-outline
                  </v-icon>
                  <span>{{ $t("money.to_card") }}</span>
                </template>
              </v-checkbox>
              <v-checkbox v-if="company && company.entity_payment" v-model="count.entity" data-testid="client-topup-entity"
                :label="$t('money.to_entity_short')" class="mt-0 mr-0" dense hide-details :disabled="count.cashless ||
                  count.cash_card ||
                  count.cash
                  " :style="count.cashless ||
                    count.cash_card ||
                    count.cash
                    ? 'opacity: 0.4;'
                    : ''
                    " v-tooltip="{
                      content: $t('money.from_entity_2'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                <template v-slot:label>
                  <v-icon class="text-center mr-2" color="secondery">
                    mdi-bank
                  </v-icon>
                  <span>{{ $t("money.to_entity") }}</span>
                </template>
              </v-checkbox>
            </v-flex>
            <v-flex v-else xs12 sm12 md12 class="d-flex align-center justify-space-between">
              <v-flex v-if="company && company.cash_payment">
                <v-checkbox v-model="count.cash" color="success" :disabled="count.cashless || count.cash_card || count.entity
                  " class="mt-0 mr-0" dense hide-details :style="count.cashless || count.cash_card || count.entity
                    ? 'opacity: 0.4;'
                    : ''
                    ">
                  <template v-slot:label>
                    <v-icon class="text-center mr-2" color="success" size="30" v-tooltip="{
                      content: $t('tooltips.cash_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-cash
                    </v-icon>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex v-if="company && company.cashless_payment">
                <v-checkbox v-model="count.cashless" color="warning" :disabled="count.cash ||
                  count.cash_card ||
                  count.entity
                  " class="mt-0 mr-0" dense hide-details :style="count.cash ||
                    count.cash_card ||
                    count.entity
                    ? 'opacity: 0.4;'
                    : ''
                    ">
                  <template v-slot:label>
                    <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                      content: $t('tooltips.terminal_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-contactless-payment-circle-outline
                    </v-icon>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex v-if="company && company.card_to_card_payment">
                <v-checkbox v-model="count.cash_card" color="info" :disabled="count.cash ||
                  count.cashless ||
                  count.entity
                  " class="mt-0 mr-0" dense hide-details :style="count.cash ||
                    count.cashless ||
                    count.entity
                    ? 'opacity: 0.4;'
                    : ''
                    ">
                  <template v-slot:label>
                    <v-icon class="text-center mr-2" color="info" v-tooltip="{
                      content: $t('money.card_to_card'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                      mdi-credit-card-check-outline
                    </v-icon>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex v-if="company && company.entity_payment">
                <v-checkbox v-model="count.entity" color="secondery" class="mt-0 mr-0" dense hide-details :disabled="count.cashless ||
                  count.cash_card ||
                  count.cash
                  " :style="count.cashless ||
                    count.cash_card ||
                    count.cash
                    ? 'opacity: 0.4;'
                    : ''
                    " v-tooltip="{
                      content: $t('tooltips.entity_count'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                  <template v-slot:label>
                    <v-icon class="text-center" color="secondery">
                      mdi-bank
                    </v-icon>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-flex>
          </v-flex>

        </v-card-text>
        <v-card-actions class="text-center">
          <v-flex class="d-flex justify-center">
            <v-btn text @click="showTopUpBalanceDialog = false, payment = {}" class="mr-2">
              {{ $t("custom.close") }}
            </v-btn>
            <v-btn color="success" @click="saveCount()" data-testid="client-topup-save">
              {{ $t("custom.save") }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FT-193 REQ-12 (CTR-04): сотрудник привязывает карту только с отметкой, что клиент дал согласие -->
    <v-dialog v-model="showTinkoffConsentDialog" :retain-focus="false" max-width="520px" :persistent="isLoading">
      <v-card data-testid="tinkoff-consent-dialog">
        <v-card-title>{{ $t("tinkoff.adding_card") }}</v-card-title>
        <v-card-text>
          <p>{{ $t("tinkoff.consent.staff_text") }}</p>
          <v-checkbox v-model="tinkoff_consent" hide-details dense data-testid="tinkoff-consent-checkbox"
            :label="$t('tinkoff.consent.staff_label')"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="isLoading" @click="showTinkoffConsentDialog = false">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" :disabled="!tinkoff_consent" :loading="isLoading" data-testid="tinkoff-consent-submit"
            @click="addCardCreate()">{{ $t("transfers.add_card") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showYandexPayDialog" :retain-focus="false" persistent max-width="520px">
      <v-card>
        <v-card-title>
          {{ $t('yandex_pay.dialog_title') }}
        </v-card-title>
        <v-card-text>
          <v-alert type="info" dense outlined class="mb-4">
            {{ $t('yandex_pay.dialog_hint') }}
          </v-alert>
          <v-text-field v-model="yandexPayAmount" :label="$t('yandex_pay.amount')" type="number" min="0"
            step="0.01" outlined :disabled="isLoadingYandexPay || yandexPayStatus === 'pending'"></v-text-field>
          <v-textarea v-model="yandexPayDescription" :label="$t('yandex_pay.description_field')" rows="1"
            auto-grow outlined :disabled="isLoadingYandexPay || yandexPayStatus === 'pending'"></v-textarea>
          <v-text-field v-if="yandexPayPaymentUrl" :value="yandexPayPaymentUrl"
            :label="$t('yandex_pay.payment_link_label')" readonly outlined dense class="mt-2"
            append-icon="mdi-content-copy" @click:append="copyToClipboard(yandexPayPaymentUrl)"></v-text-field>
          
          <!-- QR-код для оплаты -->
          <div v-if="yandexPayPaymentUrl && yandexPayQrCode" class="text-center mt-4 mb-2">
            <v-card outlined>
              <v-card-text>
                <div class="text-subtitle-2 mb-2">{{ $t('yandex_pay.qr_code_hint') }}</div>
                <img :src="yandexPayQrCode" alt="QR Code" style="max-width: 250px; width: 100%;" />
              </v-card-text>
            </v-card>
          </div>
          
          <v-alert v-if="yandexPayError" type="error" dense outlined class="mt-2">
            {{ yandexPayError }}
          </v-alert>
          <v-alert v-if="yandexPayStatus" :type="yandexPayStatusColor(yandexPayStatus)" dense outlined class="mt-2">
            {{ translateYandexPayStatus(yandexPayStatus) }}
          </v-alert>
          
          <!-- Кнопки отправки ссылки -->
          <div v-if="yandexPayPaymentUrl" class="mt-3 d-flex flex-wrap gap-2 justify-center">
            <v-btn small outlined color="primary" @click="sendYandexPayToEmail()" 
              :loading="isLoadingSendEmail" 
              class="mr-2"
              :disabled="!client.email || isLoadingSendEmail || isLoadingSendWhatsApp">
              <v-icon left small>mdi-email</v-icon>
              {{ $t('yandex_pay.send_to_email') }}
            </v-btn>
            <v-btn small outlined color="success" @click="sendYandexPayToWhatsApp()" 
              :loading="isLoadingSendWhatsApp" 
              class="mr-2"
              :disabled="!client.phone || isLoadingSendEmail || isLoadingSendWhatsApp">
              <v-icon left small>mdi-whatsapp</v-icon>
              {{ $t('yandex_pay.send_to_whatsapp') }}
            </v-btn>
            <v-btn small text color="primary" @click="openExternalLink(yandexPayPaymentUrl)">
              <v-icon left small>mdi-open-in-new</v-icon>
              {{ $t('yandex_pay.open_payment') }}
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn text @click="closeYandexPayDialog()">
            {{ $t('custom.close') }}
          </v-btn>
          <div class="d-flex align-center">
            <v-btn color="success" @click="startYandexPayPayment()"
              :loading="isLoadingYandexPay" :disabled="isLoadingYandexPay || yandexPayStatus === 'pending' || !!yandexPayPaymentUrl">
              {{ $t('yandex_pay.start_payment') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог возврата Yandex Pay -->
    <v-dialog v-model="showYandexPayRefundDialog" :retain-focus="false" persistent max-width="500px">
      <v-card>
        <v-card-title>
          {{ $t('yandex_pay.refund_title') }}
        </v-card-title>
        <v-card-text>
          <v-alert type="warning" dense outlined class="mb-4">
            {{ $t('yandex_pay.refund_warning') }}
          </v-alert>
          <div v-if="yandexPayRefundPayment" class="mb-3">
            <strong>{{ $t('yandex_pay.order_id') }}:</strong> {{ yandexPayRefundPayment.order_id }}<br>
            <strong>{{ $t('yandex_pay.payment_amount') }}:</strong> 
            {{ formatYandexPayAmount(yandexPayRefundPayment.amount) }} {{ yandexPayRefundPayment.currency || currency }}<br>
            <span v-if="yandexPayRefundPayment.refunded_amount > 0">
              <strong>{{ $t('yandex_pay.already_refunded') }}:</strong> 
              {{ formatYandexPayAmount(yandexPayRefundPayment.refunded_amount) }} {{ yandexPayRefundPayment.currency || currency }}<br>
              <strong>{{ $t('yandex_pay.available_for_refund') }}:</strong> 
              {{ formatYandexPayAmount(yandexPayRefundPayment.amount - yandexPayRefundPayment.refunded_amount) }} {{ yandexPayRefundPayment.currency || currency }}
            </span>
          </div>
          <v-text-field 
            v-model="yandexPayRefundAmount" 
            :label="$t('yandex_pay.refund_amount')" 
            type="number" 
            min="0.01"
            :max="yandexPayRefundPayment ? (yandexPayRefundPayment.amount - (yandexPayRefundPayment.refunded_amount || 0)) : 0"
            step="0.01" 
            outlined 
            :disabled="isLoadingYandexPayRefund"
            :hint="$t('yandex_pay.refund_amount_hint')"
            persistent-hint
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn text @click="closeYandexPayRefundDialog()" :disabled="isLoadingYandexPayRefund">
            {{ $t('custom.close') }}
          </v-btn>
          <v-btn color="error" @click="confirmYandexPayRefund()" 
            :loading="isLoadingYandexPayRefund" :disabled="isLoadingYandexPayRefund || !checkAdminManager">
            {{ $t('yandex_pay.refund_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог создания транзакции -->
    <v-dialog v-model="transactionDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline text-center" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
          <v-icon left :color="transactionType === 'add' ? 'success' : 'error'">
            {{ transactionType === 'add' ? 'mdi-plus' : 'mdi-minus' }}
          </v-icon>
          {{ transactionType === 'add' ? 'Пополнение баланса' : 'Списание с баланса' }}
        </v-card-title>

        <v-card-text>
          <v-divider class="mb-4"></v-divider>
          <!-- Форма транзакции -->
          <v-form>
            <v-text-field v-model="transactionAmount" :label="'Сумма (₽)'" type="number" step="0.01" min="0"
              :color="transactionType === 'add' ? 'success' : 'error'"
              :hint="transactionType === 'add' ? 'Сумма для добавления на баланс' : 'Сумма для списания с баланса'"
              persistent-hint required :disabled="isLoadingTransaction">
            </v-text-field>

            <v-textarea v-model="transactionDescription" label="Описание транзакции"
              :color="transactionType === 'add' ? 'success' : 'error'" :hint="'Краткое описание причины транзакции'"
              persistent-hint required :disabled="isLoadingTransaction" rows="1" auto-grow>
            </v-textarea>

            <!-- Предварительный просмотр -->
            <v-card flat :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'" class="pa-3 mt-4">
              <div class="text-center">
                <p class="text-caption mb-2" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
                  Предварительный просмотр:
                </p>
                <p class="text-h6 font-weight-bold"
                  :class="transactionType === 'add' ? 'success--text' : 'error--text'">
                  {{ transactionType === 'add' ? '+' : '-' }}{{ transactionAmount || '0' }} ₽
                </p>
                <p class="text-caption" :class="$vuetify.theme.dark ? 'grey--text lighten-1' : 'grey--text darken-1'">
                  {{ transactionDescription || 'Описание не указано' }}
                </p>
              </div>
            </v-card>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="isLoadingTransaction" @click="transactionDialog = false">
            Отмена
          </v-btn>
          <v-btn :color="transactionType === 'add' ? 'success' : 'error'" :loading="isLoadingTransaction"
            :disabled="!transactionAmount || !transactionDescription" @click="createTransaction">
            {{ transactionType === 'add' ? 'Пополнить' : 'Списать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Модальное окно баланса водителя -->
    <v-dialog v-model="balanceTaxiDriverDialog" max-width="600px" persistent>
      <v-card>
        <v-card-text v-if="client && balanceData">
          <!-- Информация о водителе -->
          <div class="text-center mb-4">
            <h3 class="text-h6" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">{{ client.fio }}
            </h3>
            <p class="text-caption" :class="$vuetify.theme.dark ? 'grey--text lighten-1' : 'grey--text darken-1'">
              Yandex.Taxi ID: {{ client.yandex_driver_id }}
            </p>
          </div>

          <v-divider class="mb-4"></v-divider>

          <!-- Основной баланс -->
          <v-card flat class="mb-4"
            :class="parseFloat(balanceData.balance || 0) >= 0 ? 'green--lighten-5 green--text--darken-3' : 'red--lighten-5 red--text--darken-3'"
            :color="$vuetify.theme.dark ? (parseFloat(balanceData.balance || 0) >= 0 ? 'green darken-4' : 'red darken-4') : (parseFloat(balanceData.balance || 0) >= 0 ? 'green lighten-5' : 'red lighten-5')">
            <v-card-text class="pa-4">
              <div class="d-flex justify-space-between align-center">
                <span class="text-h6 font-weight-bold" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
                  Основной баланс
                </span>
                <v-spacer></v-spacer>
                <span class="text-h5 font-weight-bold"
                  :class="parseFloat(balanceData.balance || 0) >= 0 ? 'green--text' : 'red--text'">
                  {{ parseFloat(balanceData.balance || 0).toFixed(2) }}
                </span>
              </div>
            </v-card-text>
          </v-card>

          <!-- Заблокированный баланс -->
          <v-card flat class="mb-4"
            :class="parseFloat(balanceData.blocked_balance || 0) > 0 ? 'orange--lighten-5 orange--text--darken-3' : 'grey--lighten-5 grey--text--darken-3'"
            :color="$vuetify.theme.dark ? (parseFloat(balanceData.blocked_balance || 0) > 0 ? 'orange darken-4' : 'grey darken-4') : (parseFloat(balanceData.blocked_balance || 0) > 0 ? 'orange lighten-5' : 'grey lighten-5')">
            <v-card-text class="pa-4">
              <div class="d-flex justify-space-between align-center">
                <span class="text-h6 font-weight-bold"
                  :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Заблокировано</span>
                <span class="text-h5 font-weight-bold"
                  :class="parseFloat(balanceData.blocked_balance || 0) > 0 ? 'orange--text darken-2' : 'grey--text'">
                  {{ parseFloat(balanceData.blocked_balance || 0).toFixed(2) }} ₽
                </span>
              </div>
            </v-card-text>
          </v-card>

          <!-- Детали заблокированного баланса -->
          <v-expand-transition v-if="parseFloat(balanceData.blocked_balance || 0) > 0">
            <v-card flat :color="$vuetify.theme.dark ? 'orange darken-4' : 'orange lighten-5'" class="mb-4">
              <v-card-title :class="$vuetify.theme.dark ? 'white--text' : 'orange--text darken-2'" class="py-2">
                <v-icon left :color="$vuetify.theme.dark ? 'orange lighten-2' : 'orange darken-2'">mdi-lock</v-icon>
                Детали заблокированного баланса
              </v-card-title>
              <v-card-text class="pt-0">
                <v-list dense>
                  <v-list-item v-if="balanceData.details.blocked_tips">
                    <v-list-item-content>
                      <v-list-item-title class="d-flex justify-space-between">
                        <span :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Чаевые</span>
                        <span class="font-weight-bold"
                          :class="$vuetify.theme.dark ? 'orange--text lighten-2' : 'orange--text darken-2'">
                          {{ parseFloat(balanceData.details.blocked_tips).toFixed(2) }} ₽
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="balanceData.details.blocked_cashless">
                    <v-list-item-content>
                      <v-list-item-title class="d-flex justify-space-between">
                        <span :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Безналичные</span>
                        <span class="font-weight-bold"
                          :class="$vuetify.theme.dark ? 'orange--text lighten-2' : 'orange--text darken-2'">
                          {{ parseFloat(balanceData.details.blocked_cashless).toFixed(2) }} ₽
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="balanceData.details.blocked_bonuses">
                    <v-list-item-content>
                      <v-list-item-title class="d-flex justify-space-between">
                        <span :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Бонусы</span>
                        <span class="font-weight-bold"
                          :class="$vuetify.theme.dark ? 'orange--text lighten-2' : 'orange--text darken-2'">
                          {{ parseFloat(balanceData.details.blocked_bonuses).toFixed(2) }} ₽
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="balanceData.details.blocked_financial_statements">
                    <v-list-item-content>
                      <v-list-item-title class="d-flex justify-space-between">
                        <span :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Финотчеты</span>
                        <span class="font-weight-bold"
                          :class="$vuetify.theme.dark ? 'orange--text lighten-2' : 'orange--text darken-2'">
                          {{ parseFloat(balanceData.details.blocked_financial_statements).toFixed(2) }} ₽
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="balanceData.details.blocked_closing_documents">
                    <v-list-item-content>
                      <v-list-item-title class="d-flex justify-space-between">
                        <span :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">Закрывающие документы</span>
                        <span class="font-weight-bold"
                          :class="$vuetify.theme.dark ? 'orange--text lighten-2' : 'orange--text darken-2'">
                          {{ parseFloat(balanceData.details.blocked_closing_documents).toFixed(2) }} ₽
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-expand-transition>

          <!-- Время обновления -->
          <div class="text-center">
            <v-chip small :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-2'"
              :text-color="$vuetify.theme.dark ? 'grey lighten-3' : 'grey darken-1'">
              <v-icon left small>mdi-clock-outline</v-icon>
              Обновлено: {{ new Date(balanceData.last_updated).toLocaleString('ru-RU') }}
            </v-chip>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="$vuetify.theme.dark ? 'primary' : 'primary'" :text="$vuetify.theme.dark ? false : true"
            :outlined="$vuetify.theme.dark ? true : false" @click="balanceTaxiDriverDialog = false">
            {{ $t("custom.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </span>
</template>
<script>
import { clientFullName } from "@/utils/personName";
import { secretSet } from "@/utils/integrationSecrets"; // FT-195
import { translateCountCategory } from "@/utils/countCategory";
import { periodicCreditLimitValue } from "@/utils/periodicCreditLimit";
import { isTinkoffCardBound, openPaymentUrl } from "@/utils/tinkoffCard";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import Gallery from "./Gallary";
import TaskList from "@/components/dashboard/tasks/TaskList.vue";
import RentToOwnNumberChip from "@/components/dashboard/bookings/RentToOwnNumberChip.vue";
import Uppy from "../../../plugins/uppy";
let uuid = require("uuid");
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import {
  translateDebtState as translateDebtStateText,
  translateFineState as translateFineStateText,
  translateInvoiceState as translateInvoiceStateText,
} from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { copyToClipboard as copyTextToClipboard } from '@/utils/clipboard';
import { saveAs } from "file-saver";
import xlsx from "json-as-xlsx";
import TaxiDriverInfo from "./taxi/TaxiDriverInfo";
import ClientCheckTab from "./ClientCheckTab";
import StripePaymentDialog from "./StripePaymentDialog";
import StripePaymentsTable from "./StripePaymentsTable";
import QRCode from "qrcode";
import { isMoneyDeclined } from "@/utils/moneyConfirmGuard";
import CableSubscriber from "@/mixins/CableSubscriber";
import { rentToOwnStoreEnabled } from "@/api/rentToOwn";
import AgentMarker from "@/components/agents/AgentMarker.vue";
import agentMarkerLoader from "@/components/agents/agentMarkerLoader";
import { depositHoldUnbindText } from "@/utils/depositHold";
import PhoneField from "@/components/common/PhoneField.vue";
import ClientCalls from "@/components/dashboard/clients/ClientCalls.vue"; // FT-232
import { defaultPhoneCountry } from "@/lib/phone/defaultCountry";
import { formatPhone, phoneLastDigits } from "@/lib/phone/display";
import { phoneFieldsAreValid } from "@/lib/phone/fieldValidation";

export default {
  mixins: [CableSubscriber, rentalObjectMixin],
  pullToRefresh: true,
  data() {
    return {
      client: {},
      telephony: null,
      count: {
        group: "Пополнение баланса клиента",
        operation: true,
        description: null,
        sum: 0,
        cash: false,
        cashless: false,
        cash_card: false,
        entity: false,
      },
      counts: [],
      documents: [],
      files: [],
      filepond_server: {
        // created
      },
      bookings: [],
      fines: [],
      debts: [],
      debt: {
        sum: null,
        state: this.$t("debts_state.created"),
        description: null,
        group: this.$t("add_services.rent"),
        client_id: null,
        booking_id: null,
      },
      counts_headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
      ],
      debts_headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.client"), value: "client_id", align: "center" },
        {
          text: this.$t("bookings.booking"),
          value: "booking_id",
          align: "center",
        },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("bookings.paid"), value: "paid", align: "center" },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      dataPanel: false,
      paymentDebtDialog: false,
      showTopUpBalanceDialog: false,
      showTinkoffConsentDialog: false,
      tinkoff_consent: false,
      search: null,
      gallery_items: [],
      editedFine: [],
      uploadDocuments: false,
      fines_state: [
        { text: this.$t("fines_state.created"), value: "Создан" },
        { text: this.$t("fines_state.notify"), value: "Оповещён" },
        { text: this.$t("fines_state.paid"), value: "Оплачен" },
        { text: this.$t("fines_state.refund"), value: "Возмещён" },
      ],
      headers: [
        { text: this.$t("custom.number"), value: "id", align: "center" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.editor"), align: "center" },
        { text: this.$t("cars.name"), value: "car_name", align: "center" },
        { text: this.$t("custom.start"), value: "start_date", align: "center" },
        { text: this.$t("custom.end"), value: "end_date", align: "center" },
        { text: this.$t("custom.days"), value: "days", align: "center" },
      ],
      fines_headers: [
        { text: this.$t("fines.number"), align: "center", value: "number" },
        { text: this.$t("custom.date"), value: "date", align: "center" },
        {
          text: this.$t("bookings.booking"),
          value: "booking_id",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("bookings.payment"), value: "paid", align: "center" },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      //   # Модель оплаты: 0 - посуточная, 1 - только процент, 2 - посуточная + процент
      taxi_payment_models: [
        { text: this.$t("taxi.payment_models.daily_rate"), value: 0 },
        { text: this.$t("taxi.payment_models.percent_only"), value: 1 },
        { text: this.$t("taxi.payment_models.daily_plus_percent"), value: 2 },
      ],
      invoices: [],
      search_invoices: null,
      headers_invoices: [
        { text: this.$t("custom.number"), align: "center", value: "number" },
        {
          text: this.$t("counts.date_initial"),
          value: "date",
          align: "center",
        },
        { text: this.$t("custom.client"), value: "client_id", align: "center" },
        {
          text: this.$t("bookings.booking"),
          value: "booking_id",
          align: "center",
        },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("invoices.control"), sortable: false, align: "center" },
        { text: this.$t("invoices.get"), value: "paid", align: "center" },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      // configPicker: {
      //   altFormat: "d-m-Y H:i",
      //   enableTime: true,
      //   altInput: true,
      //   time_24hr: true,
      //   plugins: [new ConfirmDatePlugin({ confirmText: "Ok" })]
      // },
      date: null,
      clients: [],
      isLoadingClients: false,
      showClientSearch: false,
      birthday_non_format: null,
      showEditBirthday: false,
      search_client: null,
      sortingBookings: { sortBy: "created_at", descending: true },
      showEdit: false,
      paymentDialog: false,
      editDialog: false,
      editDebtDialog: false,
      search_fines: null,
      customer_category: [
        { text: this.$t("customer_category.new"), value: "Новый" },
        { text: this.$t("customer_category.loyal"), value: "Лояльный" },
        { text: this.$t("customer_category.statement"), value: "Постоянный" },
        { text: this.$t("customer_category.problem"), value: "Серый" },
        { text: this.$t("customer_category.bad"), value: "Чёрный" },
      ],
      languages: [
        { text: this.$t("companies.default_lang"), value: null },
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      birthday_menu: false,
      birthday: null,
      tinkoff_headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("tinkoff.card_number"), value: "card_number", align: "center" },
        { text: this.$t("tinkoff.payment_id"), value: "payment_id", align: "center" },
        { text: this.$t("custom.status"), value: "status", align: "center" },
      ],
      tinkoff_payments: [],
      active_deposit_hold: null,
      yandex_pay_headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "amount", align: "center" },
        { text: this.$t("yandex_pay.refunded"), value: "refunded_amount", align: "center" },
        { text: this.$t("yandex_pay.order_id"), value: "order_id", align: "center" },
        { text: this.$t("custom.status"), value: "status", align: "center" },
        { text: this.$t("yandex_pay.payment_url"), value: "payment_url", align: "center" },
        { text: this.$t("custom.actions"), value: "actions", align: "center", sortable: false },
      ],
      yandex_pay_payments: [],
      stripe_payments: [],
      isStripeChannelSubscribed: false,
      isLoadingStripePayments: false,
      isYandexPayChannelSubscribed: false,
      showYandexPayDialog: false,
      yandexPayAmount: null,
      yandexPayDescription: "",
      yandexPayPaymentUrl: null,
      yandexPayQrCode: null,
      isLoadingYandexPay: false,
      isLoadingSendEmail: false,
      isLoadingSendWhatsApp: false,
      yandexPayStatus: null,
      yandexPayPollingTimer: null,
      yandexPayPollingCounter: 0,
      yandexPayPaymentId: null,
      yandexPayOrderId: null,
      yandexPayError: null,
      showYandexPayRefundDialog: false,
      yandexPayRefundPayment: null,
      yandexPayRefundAmount: null,
      isLoadingYandexPayRefund: false,
      isLoadingTransaction: false,
      transactionType: null,
      transactionAmount: null,
      transactionDescription: null,
      transactionDialog: false,
      balanceData: null,
      showBalanceModal: false,
      balanceTaxiDriverDialog: false,
      isLoadingGetFullBalance: false,
      isMobile: false,
      isLoading: false,
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (this.user_role == "agent") {
        this.$router.push("/search_free");
      }
      this.loadClientCardData();
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  beforeDestroy() {
    this.stopYandexPayPolling();
    this.unsubscribeFromYandexPayChannel();
    this.unsubscribeFromStripeChannel();
  },
  watch: {
    birthday() {
      // this.client.birthday = moment(this.birthday, "YYYY-MM-DD").format(
      //   "DD-MM-YYYY"
      // );
      // console.log(this.birthday);
    },
    search_client(val) {
      // Items have already been loaded
      if (this.clients.length > 0) return;

      // Items have already been requested
      if (this.isLoadingClients) return;

      this.isLoadingClients = true;

      // Lazily load input items
      this.axios
        .get("/api/v1/clients", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.clients.push(element.attributes);
          });
          this.clients.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                clientFullName(client) + " " +
                (client.phone
                  ? phoneLastDigits(client.phone)
                  : "");
            } else {
              client["fullname"] =
                client.short_entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                client.ogrn;
            }
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.clients_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingClients = false));
    },
    showYandexPayDialog(value) {
      if (!value) {
        this.stopYandexPayPolling();
        this.isLoadingYandexPay = false;
        this.yandexPayStatus = null;
        this.yandexPayError = null;
      }
    },
  },
  computed: {
    // FT-173 REQ-11: видимость кнопки «Оформить выкуп» — те же условия, что у
    // пункта меню Drawer.vue (REQ-01): услуга в плане без trial-ветки
    // (решение USER D1), FT-194 — и переключатель филиала (rentToOwnEnabled). isManagerPlus — из roleMixin.
    rentToOwnEntryVisible() {
      return rentToOwnStoreEnabled(this.$store.getters) && this.isManagerPlus;
    },
    // Привязка и отвязка карты Т-Банка — только сотрудникам: сервер отвечает остальным
    // 403 staff_only (api#927). isStaff — из roleMixin.
    tinkoffCardActionsVisible() {
      return this.isStaff;
    },
    clients_sources() {
      if (this.$store.getters.getCompany.company.clients_sources) {
        return this.$store.getters.getCompany.company.clients_sources;
      } else {
        return [];
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    checkAdminManager() {
      return (
        this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isManager
      );
    },
    company() {
      if (this.$store.getters.getCompany) {
        return this.$store.getters.getCompany.company;
      } else {
        return null;
      }
    },
    phoneDefaultCountry() {
      return defaultPhoneCountry({ client: this.client, company: this.company });
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    // FT-193 CHK-02: карту Т-Банка клиента привязывает и снимает только его филиал.
    tinkoffCardBound() {
      return isTinkoffCardBound(this.client);
    },
    canManageTinkoffCard() {
      return !!(this.client && this.company && this.client.company_id == this.company.id);
    },
    // Подсказка «карта в другом филиале» — только когда филиал клиента известен и чужой: у загружающегося клиента
    // и у клиента без company_id (колонка nullable) её быть не должно, иначе она врёт про филиал.
    showTinkoffOtherBranchHint() {
      const clientCompanyId = this.client && this.client.company_id;
      return !!(this.company && typeof clientCompanyId === "number" && clientCompanyId != this.company.id);
    },
    isTaxiMode() {
      return this.company && this.company.taxi_park_type && this.company.taxi_park_type !== 'not_taxi';
    },
    yandexPayAvailable() {
      return (
        this.company &&
        this.company.yandex_pay_enabled &&
        secretSet(this.company, "yandex_pay_api_key") &&
        this.company.yandex_pay_merchant_id
      );
    },
    stripeAvailable() {
      return (
        this.company &&
        this.company.stripe_enabled &&
        this.company.stripe_publishable_key &&
        secretSet(this.company, "stripe_secret_key")
      );
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
  },
  methods: {
    formatPhone,
    clientFullName,
    // FT-173 REQ-11: точка входа в мастер «Аренда с выкупом», client_id в query
    // подставляется в шаг 2 (REQ-02, ContractWizard.vue).
    openRentToOwnWizard() {
      this.$router.push({ path: "/rent_to_own/contracts/new", query: { client_id: this.client.id } });
    },
    // Статусы приходят из БД русскими строками; карта «значение → ключ» —
    // общая, в utils/localeInfra.
    translateDebtState(state) {
      return translateDebtStateText(this.$t.bind(this), state);
    },
    translateFineState(state) {
      return translateFineStateText(this.$t.bind(this), state);
    },
    translateInvoiceState(state) {
      return translateInvoiceStateText(this.$t.bind(this), state);
    },
    loadClientCardData() {
      this.isLoading = true;
      return this.axios
        .get(`/api/v1/client_card/${this.$route.params.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          // FT-184: метка «через агента» клиента едет в этом же ответе (agent_marks).
          agentMarkerLoader.prime(response.data.agent_marks);
          this.client = response.data.client;
          this.telephony = response.data.telephony || null;
          this.birthday_non_format = moment(
            this.client.birthday,
            "YYYY-MM-DD"
          ).format("DD.MM.YYYY");

          this.birthday = moment(this.client.birthday, "YYYY-MM-DD").format(
            "DD-MM-YYYY"
          );
          this.counts = response.data.counts;
          this.bookings = response.data.bookings;
          this.debts = response.data.debts;
          this.fines = response.data.fines;
          this.invoices = response.data.invoices;
          this.tinkoff_payments = response.data.tinkoff_payments || [];
          this.active_deposit_hold = response.data.active_deposit_hold || null;
          this.yandex_pay_payments = response.data.yandex_pay_payments || [];
          this.stripe_payments = response.data.stripe_payments || [];
          
          // Подписываемся на WebSocket каналы для платежных систем
          this.$nextTick(() => {
            this.subscribeToYandexPayChannel();
            this.subscribeToStripeChannel();
          });
        })
        .catch((error) => {
          // 404 = клиента нет (удалён / чужой филиал / битый id): уводим на
          // список вместо пустой карточки. Прочее — через setError.
          if (error.response?.status === 404) {
            this.$notify(this.$t("errors.client_not_found"), "", "error");
            this.$router.push({ path: `/clients` });
            return;
          }
          this.setError(error, this.$t("errors.client_load"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
    editSave() {
      // `editSave` is also reused directly by focused unit tests with a plain
      // context object. For those calls there are no rendered phone fields to check.
      if (!phoneFieldsAreValid(this.$refs && this.$refs.clientPhoneField)) return;
      if (this.isStaff) {
        this.isLoading = true;
        let client = this.client;
        let self = this;
        let name = this.capitalizeFirst(client.name);
        let middlename = this.capitalizeFirst(client.middlename);
        let lastname = this.capitalizeFirst(client.lastname);
        this.axios
          .patch(
            `/api/v1/clients/${client.id}`,
            {
              clients: {
                name: name,
                lastname: lastname,
                middlename: middlename,
                fio: client.fio,
                phone: client.phone,
                email: client.email,
                country: client.country,
                city: client.city,
                address: client.address,
                sale: client.sale,
                sale_cash: client.sale_cash,
                passport_series: client.passport_series,
                passport_number: client.passport_number,
                passport_issued: client.passport_issued,
                passport_issued_date: client.passport_issued_date,
                passport_expired_date: client.passport_expired_date,
                driver_series: client.driver_series,
                driver_number: client.driver_number,
                driver_issued: client.driver_issued,
                driver_issued_date: client.driver_issued_date,
                driver_expired_date: client.driver_expired_date,
                birthday:
                  this.birthday_non_format &&
                    moment(this.birthday_non_format, "DD.MM.YYYY").isValid
                    ? moment(this.birthday_non_format, "DD.MM.YYYY").format(
                      "YYYY-MM-DD"
                    )
                    : this.birthday_non_format,
                category: client.category,
                dop_info: client.dop_info,
                debt: client.debt,
                debt_description: client.debt_description,
                problems: client.problems,
                problems_description: client.problems_description,
                entity_name: client.entity_name,
                short_entity_name: client.short_entity_name,
                ceo: client.ceo,
                reg_form: client.reg_form,
                entity_phone: client.entity_phone,
                entity_adress: client.entity_adress,
                inn: client.inn,
                ogrn: client.ogrn,
                acc_number: client.acc_number,
                bank: client.bank,
                korr: client.korr,
                bik: client.bik,
                doc_number: client.doc_number,
                source: client.source,
                taxi_license: client.taxi_license,
                lang: client.lang,
                taxi_payment_model: client.taxi_payment_model,
                commission_percent: client.commission_percent,
                // FT-193 CTR-03: пусто = лимит компании (null). Не manager+ поле не шлёт вовсе —
                // любое значение от рядового user сервер отклонил бы 403.
                ...(this.isManagerPlus ? { periodic_credit_limit: periodicCreditLimitValue(client.periodic_credit_limit) } : {}),
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.showEdit = false;
            this.$notify(this.$t("clients.edited_title"), this.$t("clients.edited_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.client_edit"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCount() {
      if (this.isStaff) {
        let count = this.count;
        let self = this;
        if (
          (count.sum > 0 || count.sum < 0) &&
          (count.cash > 0 ||
            count.cashless > 0 ||
            count.cash_card > 0 ||
            count.entity > 0 ||
            count.cash < 0 ||
            count.cashless < 0 ||
            count.cash_card < 0 ||
            count.entity < 0)
        ) {
          this.isLoading = true;
          this.axios
            .post(
              "/api/v1/counts",
              {
                counts: {
                  group: count.group,
                  operation: true,
                  description: count.description,
                  sum: count.sum,
                  cash: count.cash,
                  cashless: count.cashless,
                  cash_card: count.cash_card,
                  entity: count.entity,
                  client_id: this.client.id,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.counts.push(response.data);
              this.client.balance = parseFloat(
                parseFloat(this.client.balance) + parseFloat(count.sum)
              ).toFixed(1);
              this.showTopUpBalanceDialog = false;
              this.count = {
                group: "Пополнение баланса клиента",
                operation: true,
                description: null,
                sum: 0,
                cash: false,
                cashless: false,
                cash_card: false,
                entity: false,
              };
              this.$notify(this.$t("counts.add_payment"), this.$t("counts.add_payment_text"), "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.count_add"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), "", "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning", 3000);
      }
    },
    // Диалог согласия открывается с пустой отметкой: согласие даёт клиент по каждой привязке отдельно.
    openTinkoffConsentDialog() {
      this.tinkoff_consent = false;
      this.showTinkoffConsentDialog = true;
    },
    addCardCreate() {
      if (!this.isStaff) {
        this.$notify(this.$t("errors.no_access"), "", "warning", 3000);
        return;
      }
      // FT-193 REQ-12: без отметки согласия запрос не уходит (сервер ответил бы 422 consent_required).
      if (this.tinkoff_consent !== true) {
        this.$notify(this.$t("tinkoff.consent.required"), "", "warning", 4000);
        return;
      }
      this.isLoading = true;
      // Создаём транзакцию у нас
      return this.axios
        .post(
          "/api/v1/integrations/tinkoff/add_card",
          {
            client_id: this.client.id,
            current_url: window.location.href,
            consent: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          // STEP-13: ответ — { payment_url }; прежний формат банка { Success, PaymentURL } — для сервера старее клиента.
          const data = response.data || {};
          const paymentUrl = data.payment_url || (data.Success == true && data.PaymentURL) || null;
          if (paymentUrl) {
            this.showTinkoffConsentDialog = false;
            this.tinkoff_consent = false;
            // Натив — @capacitor/browser, веб — новая вкладка
            openPaymentUrl(paymentUrl);
          } else {
            this.$notify(data.Message || this.$t("errors.error"), data.Details || this.$t("tinkoff.errors.bind_failed"), "error", 3000);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoading = false));
    },
    removeCardCreate() {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("tinkoff.remove_card_title"),
          text: depositHoldUnbindText(this, this.active_deposit_hold, "tinkoff.remove_card_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            // Создаём транзакцию у нас
            this.axios
              .post(
                "/api/v1/integrations/tinkoff/remove_card",
                {
                  client_id: this.client.id,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then(() => {
                this.client.tinkoff_card_number = "-";
                this.$set(this.client, "tinkoff_card_bound", false);
              })
              .catch((error) => {
                this.isLoading = false;
                this.setError(error, this.$t("errors.error"));
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning", 3000);
      }
    },
    updateClientFiles(event) {
      this.client.clients_files.unshift(event);
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("DD MMM H:mm");
      } else {
        return "-";
      }
    },
    translateDebtGroup(group) {
      const groupTranslations = {
        "Аренда": this.$t("add_services.rent"),
        "Штрафы": this.$t("add_services.fines"),
        "Повреждения": this.$t("add_services.damages"),
        "Другое": this.$t("add_services.others"),
      };
      return groupTranslations[group] || group || "";
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    stateFineColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Оплачен") {
        return "error";
      }
      if (state == "Возмещён") {
        return "success";
      }
      if (state == "Не возмещён") {
        return "error";
      }
    },
    stateDebtColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Оплачен") {
        return "success";
      }
      if (state == "Не оплачен") {
        return "red";
      }
    },
    stateInvoiceColor(state) {
      if (state == "Выставлен") {
        return "warning";
      }
      if (state == "Оплачен") {
        return "success";
      }
      if (state == "Частично оплачен") {
        return "pink";
      }
    },
    paidInvoice(invoice) {
      let invoice_sum =
        invoice.rent +
        invoice.deposit +
        invoice.delivery +
        invoice.clean +
        invoice.gas +
        invoice.damage +
        invoice.fines +
        invoice.mileage +
        invoice.hours_cost +
        invoice.insurance +
        invoice.equipment +
        (invoice.addons_cost || 0) + // FT-102 REQ-07: каталожное оборудование
        invoice.other;
      if (invoice_sum == invoice.paid && invoice_sum > 0 && invoice.paid > 0) {
        return this.$t("invoices.paid");
      } else if (invoice_sum < invoice.paid) {
        return this.$t("invoices.extra_paid");
      } else if (invoice_sum > 0 && invoice_sum > invoice.paid) {
        return this.$t("invoices.low_paid");
      } else if (invoice_sum > 0 && invoice.paid == 0) {
        return this.$t("invoices.no_income");
      } else {
        return `-`;
      }
    },
    toXlsx() {
      if (this.isStaff) {
        let self = this;
        let data = [
          {
            sheets: "Payments",
            columns: [
              { label: "ID", value: "id" },
              { label: this.$t("clients.created_at"), value: "created_at" },
              { label: this.$t("custom.amount"), value: "sum" },
              { label: this.$t("custom.operation"), value: "operation" },
              { label: this.$t("counts.about"), value: "description" },
              { label: this.$t("money.terminal"), value: "cashless" },
              { label: this.$t("money.card_to_card"), value: "cash_card" },
              { label: this.$t("money.cash"), value: "cash" },
              { label: this.$t("money.from_entity"), value: "entity" },
              {
                label: this.$t("custom.group"), value: (row) => {
                  return this.translateCategory(row.group);
                }
              },
              { label: this.$t("custom.car"), value: "car_code" },
              { label: this.$t("bookings.booking"), value: "booking_id" },
              { label: this.$t("debts.debt"), value: "debt_id" },
              { label: this.$t("employers.partner"), value: "investor_id" },
              { label: this.$t("counts.completed"), value: "completed" },
            ],
            content: this.filtered_counts && this.filtered_counts.length > 0 ? this.filtered_counts : this.counts,
          },
        ];
        let settings = {
          fileName: "client_payments", // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeMode: "write", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
          writeOptions: {
            bookType: "xlsx",
            type: "array",
          }, // Style options from https://docs.sheetjs.com/docs/api/write-options
          RTL: false, // Display the columns from right-to-left (the default value is false)
        };
        let wbout = xlsx(data, settings);
        var blob_data = new Blob([new Uint8Array(wbout)], { type: "application/octet-stream" });
        if (!this.isNative) {
          saveAs(blob_data, 'client_payments.xlsx');
        } else {
          if (Filesystem.checkPermissions()) {
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }
            getBase64FromBlob(blob_data).then(
              (base64) => {
                // save file
                async function writeFile() {
                  return await Filesystem.writeFile({
                    path: 'client_payments.xlsx',
                    data: base64,
                    directory: Directory.Documents,
                  });
                }
                let file_uri = null
                let writedFile = writeFile().then((getUriResult) => {
                  // share file opened file
                  let shareFile = async () => {
                    await Share.share({
                      title: 'Download document',
                      files: [getUriResult.uri],
                    }).catch((error) => {
                      console.log("shareFile", error)
                    });
                  };
                  let sharedFile = shareFile();
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              }
            );
          } else {
            Filesystem.requestPermissions();
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning", 3000);
      }
    },
    // Раскладка распознанных полей живёт ТОЛЬКО на бэкенде
    // (Yandex::OcrClientMapper): к моменту ответа клиент уже сохранён. Здесь
    // просто перечитываем карточку — так же, как делает CRM-дровер.
    //
    // Раньше тут была вторая, своя раскладка, и она побеждала: editSave()
    // PATCH'ит клиента целиком, поэтому серверные значения откатывались
    // локальными. Вместе с её ошибками — даты водительского писались в
    // ПАСПОРТНЫЕ поля, moment() без формата переставлял день с месяцем
    // (05.11.2020 → 2020-05-11), оборотная сторона прав затирала номер,
    // заполненный лицевой, а дата выдачи приклеивалась к органу выдачи.
    onDocumentRecognized() {
      return this.loadClientCardData()
        .then(() => {
          this.dataPanel = 0;
        })
        .catch((error) => {
          // Тост «документ распознан» Gallary уже показала, и он не врёт:
          // бэкенд действительно сохранил клиента. Упало перечитывание, то есть
          // на экране осталась карточка ДО распознавания — без этой ветки
          // пользователь решил бы, что распознавание ничего не заполнило.
          this.setError(error, this.$t("errors.client_load"));
        });
    },
    replaceToWhatsAppPage() {
      if (this.client && this.client.id) {
        this.$router.push({ path: `/whatsapp_client/${this.client.id}` });
      }
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    openTransactionDialog(type) {
      this.transactionType = type;
      this.transactionAmount = '';
      this.transactionDescription = '';
      this.transactionDialog = true;
    },
    async createTransaction() {
      if (!this.transactionAmount || !this.transactionDescription) {
        this.$notify('Ошибка', 'Заполните все поля', 'error', 5000);
        return;
      }

      const amount = parseFloat(this.transactionAmount);
      if (isNaN(amount) || amount <= 0) {
        this.$notify('Ошибка', 'Введите корректную сумму', 'error', 5000);
        return;
      }

      // Определяем знак суммы
      const signedAmount = this.transactionType === 'add' ? amount.toString() : `-${amount.toString()}`;

      this.isLoadingTransaction = true;
      try {
        const response = await this.axios.post(
          `/api/v1/taxi/drivers/${this.client.id}/transaction`,
          {
            yandex_integration: {
              amount: signedAmount,
              description: this.transactionDescription,
              kind: 'other'
            }
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        );

        if (response.data.success) {
          this.transactionDialog = false;
          // Обновляем баланс водителя через 35 секунд (с небольшим буфером)
          setTimeout(() => {
            this.getCurrentDriverBalance(this.client);
          }, 35000);
        } else {
          this.$notify('Ошибка', response.data.error || 'Ошибка создания транзакции', 'error', 5000);
        }
      } catch (error) {
        // Оператор сам отказался отправлять необычно крупную сумму (moneyConfirmGuard):
        // запрос отменён ДО отправки, сбоя не было. Этот catch показывает ошибку МИМО
        // setErrorMixin, поэтому проверка нужна здесь (ревью 29.08.2026, Codex P1).
        if (isMoneyDeclined(error)) return;
        console.error('Error creating transaction:', error);
        this.$notify('Ошибка', 'Ошибка создания транзакции', 'error', 5000);
      } finally {
        this.isLoadingTransaction = false;
      }
    },
    async getFullBalance() {
      if (!this.client.yandex_driver_id) {
        this.$notify('Ошибка', 'У водителя нет Yandex.Taxi ID', 'error', 5000);
        return;
      }

      this.isLoadingGetFullBalance = true;
      this.axios.get(
        `/api/v1/taxi/drivers/${this.client.id}/balance`,
        {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        }
      ).then((response) => {
        if (response.data.success) {
          this.balanceData = response.data.data.balance;
          this.client.balance = response.data.data.balance.balance;
          this.client.blocked_balance = response.data.data.balance.blocked_balance;
          this.balanceTaxiDriverDialog = true;
        } else {
          this.$notify('Ошибка', response.data.error || 'Ошибка получения баланса', 'error', 5000);
        }
      }).catch((error) => {
        console.error('Error fetching driver balance:', error);
        this.$notify('Ошибка', 'Ошибка получения баланса водителя', 'error', 5000);
      }).finally(() => (this.isLoadingGetFullBalance = false));
    },
    getCurrentDriverBalance() {
      this.getFullBalance(this.client);
    },
    balanceColor() {
      if (parseFloat(this.client.balance || 0) >= 0) {
        if (this.$vuetify.theme.dark) {
          return 'white--text';
        } else {
          return 'black--text';
        }
      } else {
        if (this.$vuetify.theme.dark) {
          return 'red--text';
        } else {
          return 'red--text';
        }
      }
    },
    capitalizeFirst(text) {
      if (text) {
        return text[0].toUpperCase() + text.substring(1);
      }
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("DD MMM H:mm");
    },
    formatCreatedAtWithYear(date) {
      if (!date) return "-";
      // violation_date хранится как wall-clock в UTC-обёртке (то же,
      // что показывают Госуслуги). См. Fines.vue и rentalman-api
      // Shtrafus::FineProcessorService#parse_datetime.
      const d = new Date(date);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getUTCDate())}-${pad(d.getUTCMonth() + 1)}-${String(d.getUTCFullYear()).slice(2)} ${d.getUTCHours()}:${pad(d.getUTCMinutes())}`;
    },
    returnDate(item) {
      return moment.parseZone(item, "YYYY-MM-DD H:mm").format("DD MMM H:mm");
    },
    replaceToBooking(booking) {
      this.$router.push({ path: `/bookings/${booking.id}` });
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        this.paymentsPanel = [];
        return true;
      } else {
        this.isMobile = false;
        this.paymentsPanel = 0;
        return false;
      }
    },
    openExternalLink(url) {
      if (!url) {
        return;
      }
      window.open(url, "_blank");
    },
    async copyToClipboard(value) {
      if (!value) {
        return;
      }
      try {
        await copyTextToClipboard(value);
        this.$notify(this.$t("yandex_pay.copy_success"), "", "success", 3000);
      } catch (error) {
        this.$notify(this.$t("yandex_pay.copy_failed"), "", "error", 3000);
      }
    },
    openYandexPayDialog() {
      if (!this.yandexPayAvailable) {
        this.$notify(this.$t("yandex_pay.not_configured_title"), this.$t("yandex_pay.not_configured_text"), "warning", 4000);
        return;
      }
      this.stopYandexPayPolling();
      this.yandexPayAmount = null;
      this.yandexPayDescription = "";
      this.yandexPayPaymentUrl = null;
      this.yandexPayStatus = null;
      this.yandexPayError = null;
      this.yandexPayPaymentId = null;
      this.yandexPayOrderId = null;
      this.showYandexPayDialog = true;
    },
    startYandexPayPayment() {
      if (!this.client || !this.client.id) {
        this.$notify(this.$t("yandex_pay.no_client_error"), "", "warning", 4000);
        return;
      }
      if (!this.yandexPayAvailable) {
        this.$notify(this.$t("yandex_pay.not_configured_title"), this.$t("yandex_pay.not_configured_text"), "warning", 4000);
        return;
      }
      let amountValue = this.yandexPayAmount ? this.yandexPayAmount.toString().replace(",", ".") : "";
      const amount = parseFloat(amountValue);
      if (!amount || amount <= 0) {
        this.$notify(this.$t("yandex_pay.amount_error"), "", "warning", 4000);
        return;
      }
      this.isLoadingYandexPay = true;
      this.yandexPayError = null;
      this.yandexPayStatus = "pending";
      const payload = {
        client_id: this.client.id,
        amount: amount.toFixed(2),
      };
      if (this.yandexPayDescription && this.yandexPayDescription.length > 0) {
        payload.description = this.yandexPayDescription;
      }
      this.axios
        .post("/api/v1/integrations/yandex_pay/orders", payload, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          if (!response.data || !response.data.payment_url) {
            this.yandexPayStatus = null;
            this.yandexPayError = this.$t("yandex_pay.no_payment_url");
            return;
          }
          this.yandexPayPaymentUrl = response.data.payment_url;
          this.yandexPayPaymentId = response.data.payment_id;
          this.yandexPayOrderId = response.data.order_id;
          
          // Генерируем QR-код для ссылки на оплату
          this.generateYandexPayQrCode(response.data.payment_url);
          
          this.$notify(this.$t("yandex_pay.link_ready_title"), this.$t("yandex_pay.link_ready_text"), "info", 5000);
          this.startYandexPayPolling();
        })
        .catch((error) => {
          this.yandexPayStatus = null;
          this.yandexPayError =
            (error.response && error.response?.data && error.response?.data.error) || error.message || this.$t("yandex_pay.status_error");
          this.setError(error, this.$t("yandex_pay.status_error"));
        })
        .finally(() => (this.isLoadingYandexPay = false));
    },
    startYandexPayPolling() {
      this.stopYandexPayPolling();
      this.yandexPayStatus = 'pending';
      
      // Подписка на WebSocket канал происходит в mounted, дублировать не нужно
    },
    closeYandexPayDialog() {
      this.stopYandexPayPolling();
      this.showYandexPayDialog = false;
      this.yandexPayAmount = null;
      this.yandexPayDescription = "";
      this.yandexPayPaymentUrl = null;
      this.yandexPayQrCode = null;
      this.yandexPayStatus = null;
      this.yandexPayPaymentId = null;
      this.yandexPayOrderId = null;
      this.yandexPayError = null;
    },
    generateYandexPayQrCode(url) {
      if (!url) {
        this.yandexPayQrCode = null;
        return;
      }
      
      QRCode.toDataURL(url, {
        width: 250,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      })
        .then(dataUrl => {
          this.yandexPayQrCode = dataUrl;
        })
        .catch(err => {
          console.error('Ошибка генерации QR-кода:', err);
          this.yandexPayQrCode = null;
        });
    },
    stopYandexPayPolling() {
      // Отписка от WebSocket канала происходит в beforeDestroy, здесь не отписываемся
      this.yandexPayPollingCounter = 0;
    },
    handleYandexPayUpdate(data) {
      if (!data || !data.yandex_pay_payment) {
        return;
      }
      
      const payment = data.yandex_pay_payment;
      
      // Проверяем, что это наш платёж
      if (this.yandexPayPaymentId && payment.id !== this.yandexPayPaymentId) {
        return;
      }
      if (this.yandexPayOrderId && payment.order_id !== this.yandexPayOrderId) {
        return;
      }
      
      // Обновляем статус
      this.yandexPayStatus = payment.status;
      if (payment.payment_url) {
        this.yandexPayPaymentUrl = payment.payment_url;
      }
      
      // Обрабатываем финальные статусы
      if (payment.status === "success") {
        this.$notify(this.$t("yandex_pay.success_message"), "", "success", 4000);
        this.loadClientCardData().finally(() => {
          this.closeYandexPayDialog();
        });
      } else if (payment.status === "failed") {
        this.yandexPayError = this.$t("yandex_pay.failed_message");
        this.$notify(this.$t("yandex_pay.failed_message"), "", "error", 4000);
        // Обновляем только список платежей при ошибке
        this.loadYandexPayPayments();
      } else if (payment.status === "cancelled") {
        this.stopYandexPayPolling();
        this.yandexPayError = this.$t("yandex_pay.cancelled_message");
        this.$notify(this.$t("yandex_pay.cancelled_message"), "", "warning", 4000);
        // Обновляем только список платежей при отмене
        this.loadYandexPayPayments();
      }
      
      // Для статуса "success" не нужно дополнительно загружать платежи,
      // так как loadClientCardData() уже загрузил все данные
    },
    handleStripePaymentUpdate(data) {
      if (!data || !data.stripe_payment) {
        return;
      }
      
      const payment = data.stripe_payment;
      
      // Передаем обновление в диалог если открыт (проверяем оба ref'а)
      if (this.$refs.stripePaymentDialog) {
        this.$refs.stripePaymentDialog.handlePaymentUpdate(data);
      }
      if (this.$refs.stripePaymentDialog2) {
        this.$refs.stripePaymentDialog2.handlePaymentUpdate(data);
      }
      
      // Обрабатываем финальные статусы
      if (payment.status === "success") {
        this.$notify(this.$t("stripe_payment.success_message"), "", "success", 4000);
        this.loadClientCardData();
      } else if (payment.status === "failed") {
        this.$notify(this.$t("stripe_payment.failed_message"), "", "error", 4000);
      } else if (payment.status === "cancelled") {
        this.$notify(this.$t("stripe_payment.cancelled_message"), "", "warning", 4000);
      }
      
      // Обновляем список платежей
      this.loadStripePayments();
    },
    loadYandexPayPayments() {
      if (!this.client || !this.client.id) {
        return;
      }
      this.axios
        .get("/api/v1/integrations/yandex_pay/payments", {
          params: { client_id: this.client.id },
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.yandex_pay_payments = (response.data && response.data.payments) || [];
        })
        .catch((error) => {
          console.error("Failed to load Yandex Pay payments:", error);
        });
    },
    loadStripePayments() {
      if (!this.client || !this.client.id) {
        return;
      }
      
      // Предотвращаем одновременные запросы
      if (this.isLoadingStripePayments) {
        console.log("Stripe payments already loading, skipping...");
        return;
      }
      
      this.isLoadingStripePayments = true;
      
      this.axios
        .get("/api/v1/integrations/stripe_payments/payments", {
          params: { client_id: this.client.id },
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.stripe_payments = (response.data && response.data.payments) || [];
        })
        .catch((error) => {
          console.error("Failed to load Stripe payments:", error);
          // Не показываем ошибку пользователю, чтобы не спамить при проблемах с сетью
        })
        .finally(() => {
          this.isLoadingStripePayments = false;
        });
    },
    subscribeToYandexPayChannel() {
      if (!this.client || !this.client.id || !this.yandexPayAvailable) return;
      // FT-066 switch pattern (id-aware): no-op if already subscribed to THIS client (dedups
      // refresh of the same client, behavior 1:1); if subscribed to a DIFFERENT client (or not
      // subscribed) → drop the prior held sub + re-subscribe for the current client. The
      // flag-only guard (!isSubscribed) could block re-subscription on a live client change.
      if (this.isYandexPayChannelSubscribed && this.yandexSubClientId === this.client.id) return;
      this.$cableUnsubscribe(this.yandexSub);
      // received → handleYandexPayUpdate (this-rebinding via arrow). Mixin auto-unsubscribes too.
      this.yandexSub = this.$cableSubscribe(
        { channel: 'YandexPayPaymentChannel', client_id: this.client.id },
        { received: (data) => this.handleYandexPayUpdate(data) }
      );
      this.yandexSubClientId = this.client.id;
      this.isYandexPayChannelSubscribed = true;
      console.log(`Subscribed to YandexPayPaymentChannel for client ${this.client.id}`);
    },
    unsubscribeFromYandexPayChannel() {
      if (this.isYandexPayChannelSubscribed) {
        this.$cableUnsubscribe(this.yandexSub);
        this.yandexSub = null;
        this.yandexSubClientId = null;
        this.isYandexPayChannelSubscribed = false;
        console.log("Unsubscribed from YandexPayPaymentChannel");
      }
    },
    subscribeToStripeChannel() {
      if (!this.client || !this.client.id || !this.stripeAvailable) return;
      // FT-066 switch pattern (id-aware) + structural fix for the card↔dialog Stripe collision:
      // each ClientCard holds its OWN StripePaymentChannel object (no shared name slot). No-op if
      // already on THIS client (refresh dedup, 1:1); re-subscribe if the client id changed.
      if (this.isStripeChannelSubscribed && this.stripeSubClientId === this.client.id) return;
      this.$cableUnsubscribe(this.stripeSub);
      // received → handleStripePaymentUpdate, which forwards to the dialog refs.
      this.stripeSub = this.$cableSubscribe(
        { channel: 'StripePaymentChannel', client_id: this.client.id },
        { received: (data) => this.handleStripePaymentUpdate(data) }
      );
      this.stripeSubClientId = this.client.id;
      this.isStripeChannelSubscribed = true;
      console.log(`Subscribed to StripePaymentChannel for client ${this.client.id}`);
    },
    unsubscribeFromStripeChannel() {
      if (this.isStripeChannelSubscribed) {
        this.$cableUnsubscribe(this.stripeSub);
        this.stripeSub = null;
        this.stripeSubClientId = null;
        this.isStripeChannelSubscribed = false;
        console.log("Unsubscribed from StripePaymentChannel");
      }
    },
    handleStripePaymentsUpdated() {
      this.loadStripePayments();
      this.loadClientCardData();
    },
    viewStripePayment(payment) {
      // Проверяем оба ref'а (для entity и не-entity клиентов)
      const dialog = this.$refs.stripePaymentDialog || this.$refs.stripePaymentDialog2;
      if (dialog) {
        dialog.paymentUrl = payment.payment_url;
        dialog.paymentId = payment.id;
        dialog.paymentAmount = payment.amount;
        dialog.paymentDescription = '';
        
        if (payment.payment_url) {
          dialog.generateQrCode(payment.payment_url);
        }
        
        dialog.paymentStatus = payment.status;
        dialog.showDialog = true;
      }
    },
    refundStripePayment(payment) {
      // Проверяем оба ref'а (для entity и не-entity клиентов)
      const dialog = this.$refs.stripePaymentDialog || this.$refs.stripePaymentDialog2;
      if (dialog) {
        dialog.openRefundDialog(payment);
      }
    },
    refundYandexPayPayment(payment) {
      this.yandexPayRefundPayment = payment;
      const availableForRefund = payment.amount - (payment.refunded_amount || 0);
      this.yandexPayRefundAmount = availableForRefund;
      this.showYandexPayRefundDialog = true;
    },
    closeYandexPayRefundDialog() {
      this.showYandexPayRefundDialog = false;
      this.yandexPayRefundPayment = null;
      this.yandexPayRefundAmount = null;
    },
    viewYandexPayPayment(payment) {
      // Открываем диалог с существующей ссылкой на оплату
      this.yandexPayPaymentUrl = payment.payment_url;
      this.yandexPayPaymentId = payment.id;
      this.yandexPayAmount = payment.amount;
      this.yandexPayDescription = "";
      
      // Генерируем QR-код для существующей ссылки
      if (payment.payment_url) {
        this.generateYandexPayQrCode(payment.payment_url);
      }
      
      // Открываем диалог
      this.showYandexPayDialog = true;
    },
    sendYandexPayToEmail() {
      if (!this.client.email) {
        this.$notify(
          this.$t("yandex_pay.no_email_title"),
          this.$t("yandex_pay.no_email_text"),
          "warning",
          3000
        );
        return;
      }

      if (!this.yandexPayPaymentId) {
        this.$notify(
          this.$t("errors.error"),
          this.$t("yandex_pay.no_payment_url"),
          "error",
          3000
        );
        return;
      }

      this.isLoadingSendEmail = true;
      this.axios
        .post(
          `/api/v1/integrations/yandex_pay/payments/${this.yandexPayPaymentId}/send_email`,
          {},
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.$notify(
            this.$t("yandex_pay.email_sent_title"),
            this.$t("yandex_pay.email_sent_text", { email: this.client.email }),
            "success",
            4000
          );
        })
        .catch((error) => {
          const errorMessage =
            (error.response && error.response?.data && error.response?.data.error) ||
            this.$t("yandex_pay.email_send_error");
          this.$notify(
            this.$t("errors.error"),
            errorMessage,
            "error",
            4000
          );
        })
        .finally(() => {
          this.isLoadingSendEmail = false;
        });
    },
    sendYandexPayToWhatsApp() {
      if (!this.client.phone) {
        this.$notify(
          this.$t("yandex_pay.no_phone_title"),
          this.$t("yandex_pay.no_phone_text"),
          "warning",
          3000
        );
        return;
      }

      if (!this.yandexPayPaymentId) {
        this.$notify(
          this.$t("errors.error"),
          this.$t("yandex_pay.no_payment_url"),
          "error",
          3000
        );
        return;
      }

      this.isLoadingSendWhatsApp = true;
      this.axios
        .post(
          `/api/v1/integrations/yandex_pay/payments/${this.yandexPayPaymentId}/send_whatsapp`,
          {},
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          // Если есть whatsapp_url, открываем его
          if (response.data.whatsapp_url) {
            window.open(response.data.whatsapp_url, "_blank");
          }
          this.$notify(
            this.$t("yandex_pay.whatsapp_sent_title"),
            this.$t("yandex_pay.whatsapp_sent_text"),
            "success",
            4000
          );
        })
        .catch((error) => {
          const errorMessage =
            (error.response && error.response?.data && error.response?.data.error) ||
            this.$t("yandex_pay.whatsapp_send_error");
          this.$notify(
            this.$t("errors.error"),
            errorMessage,
            "error",
            4000
          );
        })
        .finally(() => {
          this.isLoadingSendWhatsApp = false;
        });
    },
    confirmYandexPayRefund() {
      if (!this.yandexPayRefundPayment || !this.yandexPayRefundAmount) {
        return;
      }

      const refundAmount = parseFloat(this.yandexPayRefundAmount);
      const availableForRefund = this.yandexPayRefundPayment.amount - (this.yandexPayRefundPayment.refunded_amount || 0);
      
      if (refundAmount <= 0 || refundAmount > availableForRefund) {
        this.$notify(
          this.$t("yandex_pay.refund_amount_error_title"),
          this.$t("yandex_pay.refund_amount_error_text"),
          "error",
          4000
        );
        return;
      }

      this.isLoadingYandexPayRefund = true;
      this.axios
        .post(`/api/v1/integrations/yandex_pay/payments/${this.yandexPayRefundPayment.id}/refund`, {
          refund_amount: refundAmount,
        }, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          const isPartialRefund = refundAmount < availableForRefund;
          const successMessage = isPartialRefund 
            ? this.$t("yandex_pay.partial_refund_success")
            : this.$t("yandex_pay.refund_success");
          this.$notify(successMessage, "", "success", 4000);
          this.closeYandexPayRefundDialog();
          // loadClientCardData уже загружает все данные включая платежи
          this.loadClientCardData();
        })
        .catch((error) => {
          const errorMessage = (error.response && error.response?.data && error.response?.data.error) || 
                               this.$t("yandex_pay.refund_error");
          const errorDetails = error.response && error.response?.data && error.response?.data.details;
          this.$notify(
            this.$t("yandex_pay.refund_error"), 
            errorDetails || errorMessage, 
            "error", 
            5000
          );
        })
        .finally(() => {
          this.isLoadingYandexPayRefund = false;
        });
    },
    translateYandexPayStatus(status) {
      if (!status) {
        return this.$t("yandex_pay.status_unknown");
      }
      const normalized = status.toLowerCase();
      switch (normalized) {
        case "success":
          return this.$t("yandex_pay.status_success");
        case "failed":
          return this.$t("yandex_pay.status_failed");
        case "cancelled":
          return this.$t("yandex_pay.status_cancelled");
        case "pending":
          return this.$t("yandex_pay.status_pending");
        case "created":
          return this.$t("yandex_pay.status_created");
        default:
          return status;
      }
    },
    yandexPayStatusColor(status) {
      if (!status) {
        return "info";
      }
      const normalized = status.toLowerCase();
      if (normalized === "success") {
        return "success";
      }
      if (normalized === "failed") {
        return "error";
      }
      if (normalized === "cancelled") {
        return "warning";
      }
      return "info";
    },
    formatYandexPayAmount(value) {
      if (!value && value !== 0) {
        return "0.00";
      }
      const numeric = parseFloat(value);
      if (Number.isNaN(numeric)) {
        return value;
      }
      return numeric.toFixed(2);
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
  },
  components: {
    ClientCalls,
    RentToOwnNumberChip,
    TaskList,
    Gallery,
    Uppy,
    TaxiDriverInfo,
    ClientCheckTab,
    StripePaymentDialog,
    StripePaymentsTable,
    AgentMarker,
    PhoneField,
  },
};
</script>
